
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iWI3x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hYoU4 = parcelRequire("hYoU4");


var $4arST = parcelRequire("4arST");

const $6e8e2f3a6d87036a$export$9540a34fb4a0cc39 = {
    COLLAB_PROVIDER: 'RETRIEVE_EDITOR_TITLE_AND_CONTENT_ERROR_COLLAB_PROVIDER',
    ACK_STATE: 'RETRIEVE_EDITOR_TITLE_AND_CONTENT_ERROR_ACK_STATE'
};
const $6e8e2f3a6d87036a$export$502db6186656215e = ({ onCollabError: onCollabError, editorActions: editorActions })=>{
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const getCollabProviderState = (0, $4arST.useGetCollabProviderState)({
        editorActions: editorActions,
        collabEditProvider: collabEditProvider,
        reason: 'get-content'
    });
    const retrieveEditorTitleAndContent = (0, $42omo.useCallback)(()=>{
        return new Promise((resolve, reject)=>{
            if (!collabEditProvider) return reject($6e8e2f3a6d87036a$export$9540a34fb4a0cc39.COLLAB_PROVIDER);
            return Promise.resolve(getCollabProviderState(true)).then((ackState)=>{
                if (!ackState) return reject($6e8e2f3a6d87036a$export$9540a34fb4a0cc39.ACK_STATE);
                const { title: title, content: content, stepVersion: stepVersion } = ackState;
                return resolve({
                    title: title,
                    adf: content,
                    ncsStepVersion: stepVersion.toString()
                });
            }).catch((error)=>{
                onCollabError();
                reject(error);
            });
        });
    }, [
        onCollabError,
        getCollabProviderState,
        collabEditProvider
    ]);
    return {
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
    };
};
module.exports["useRetrieveEditorTitleAndContent"] = $6e8e2f3a6d87036a$export$502db6186656215e;

});

parcelRegister("fBnV3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");

const $189947004745ce10$export$d8065178219c808a = (flags)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)(()=>{
        flags.showErrorFlag({
            title: formatMessage({
                id: "collab.status.error"
            }),
            description: formatMessage({
                id: "collab.status.tooltip.error"
            })
        });
    }, [
        flags,
        formatMessage
    ]);
};
module.exports["useHandleCollabError"] = $189947004745ce10$export$d8065178219c808a;

});

parcelRegister("beK3g", function(module, exports) {
/* useSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lOkIA = parcelRequire("lOkIA");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $510b459ad72a4bad$var$ReadOnlyOverlay = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71j9a _4t3i1osq _kqsw1n9t _1ltvidpf _154iidpf _1bsb1osq _1pby1ayy",
            __cmplp.className
        ])
    });
});
const $510b459ad72a4bad$var$TransparentReadOnlyOverlay = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhk1j28 _80omv00u _4t3i1osq _kqswstnw _1ltvidpf _154iidpf _1bsb1osq _1pby1ayy",
            __cmplp.className
        ])
    });
});
const $510b459ad72a4bad$export$7f7cbe89f1eacd2 = ({ shouldShowSpinner: shouldShowSpinner, isOverlayTransparent: isOverlayTransparent = false })=>{
    if (!shouldShowSpinner) return null;
    if (isOverlayTransparent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($510b459ad72a4bad$var$TransparentReadOnlyOverlay, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
        size: "large"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($510b459ad72a4bad$var$ReadOnlyOverlay, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
        size: "medium"
    }));
};
const $510b459ad72a4bad$export$21495182eeff761c = ()=>{
    const [shouldShowSpinner, setShouldShowSpinner] = (0, $42omo.useState)(false);
    const showSpinner = (0, $42omo.useCallback)(()=>setShouldShowSpinner(true), []);
    const hideSpinner = (0, $42omo.useCallback)(()=>setShouldShowSpinner(false), []);
    return {
        showSpinner: showSpinner,
        hideSpinner: hideSpinner,
        shouldShowSpinner: shouldShowSpinner
    };
};
module.exports["Spinner"] = $510b459ad72a4bad$export$7f7cbe89f1eacd2;
module.exports["useSpinner"] = $510b459ad72a4bad$export$21495182eeff761c;

});

parcelRegister("9ovft", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $gfqXk = parcelRequire("gfqXk");


var $kDIns = parcelRequire("kDIns");


var $aHcFH = parcelRequire("aHcFH");


var $cZa7r = parcelRequire("cZa7r");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $fHAwL = parcelRequire("fHAwL");


var $lb2Lp = parcelRequire("lb2Lp");


var $3BPrE = parcelRequire("3BPrE");


var $03oqz = parcelRequire("03oqz");

const $c13ad953d7aa53c9$export$7d464c122ca911c0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { contentId: contentId, contentType: contentType, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache } = t0;
    const pubSubResourceType = contentType || "page";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const subscriptions = (0, $42omo.useRef)(t1);
    const [t2, t3] = (0, $8i27m.useCommentsData)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = t2;
    const { addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, updateCommentBody: updateCommentBody, reopenParentComment: reopenParentComment } = t3;
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const orderedActiveAnnotationIdListRef = (0, $42omo.useRef)(orderedActiveAnnotationIdList);
    const { editorViewProps: editorViewProps } = (0, $cZa7r.useAnnotations)();
    const { setContentId: setContentId, setContentType: setContentType, addSubscriber: addSubscriber, removeSubscriber: removeSubscriber } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    let t4;
    if ($[1] !== editorViewProps) {
        t4 = editorViewProps || {};
        $[1] = editorViewProps;
        $[2] = t4;
    } else t4 = $[2];
    const { annotations: t5 } = t4;
    let t6;
    if ($[3] !== t5) {
        t6 = t5 === undefined ? [] : t5;
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    const annotations = t6;
    const selectedAnnotationId = annotations[0]?.id;
    let t7;
    let t8;
    if ($[5] !== orderedActiveAnnotationIdList) {
        t7 = ()=>{
            orderedActiveAnnotationIdListRef.current = orderedActiveAnnotationIdList;
        };
        t8 = [
            orderedActiveAnnotationIdList
        ];
        $[5] = orderedActiveAnnotationIdList;
        $[6] = t7;
        $[7] = t8;
    } else {
        t7 = $[6];
        t8 = $[7];
    }
    (0, $42omo.useEffect)(t7, t8);
    let t9;
    if ($[8] !== contentId || $[9] !== triggerAnalyticsEvent || $[10] !== updateUnresolvedInlineComment) {
        t9 = (event, markerRef)=>{
            const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            emitter.emit(event, markerRef);
            const annotationIds = orderedActiveAnnotationIdListRef.current.map($c13ad953d7aa53c9$var$_temp);
            if (triggerAnalyticsEvent) (0, $kDIns.getEditorResolvedState)({
                annotations: (0, $aHcFH.getSortedMarkerRefs)([
                    ...annotationIds,
                    markerRef
                ], "edit"),
                pageId: contentId,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment
            });
        };
        $[8] = contentId;
        $[9] = triggerAnalyticsEvent;
        $[10] = updateUnresolvedInlineComment;
        $[11] = t9;
    } else t9 = $[11];
    const handleOnPublicationEvent = t9;
    let t10;
    if ($[12] !== addCommentInCache || $[13] !== addNewCommentThreads || $[14] !== addReplyToCommentThread || $[15] !== contentId || $[16] !== currentUserId || $[17] !== deleteCommentInCache || $[18] !== handleOnPublicationEvent || $[19] !== reopenParentComment || $[20] !== selectedAnnotationId || $[21] !== setStoredCommentData || $[22] !== storedCommentData || $[23] !== updateCommentBody || $[24] !== updateRemovedCommentIdsMap || $[25] !== updateUnreadCommentIDSet) {
        t10 = async (event_0, payload)=>{
            if (!event_0) return;
            let inlineCommentRequestBody;
            if ((0, $9wGTI.fg)("cc_fps_migration_comments") && (0, $9wGTI.fg)("confluence_enable_subscriptions-context-provider")) inlineCommentRequestBody = payload?.[event_0];
            else inlineCommentRequestBody = payload.inlineCommentRequestBody;
            const { accountId: accountId } = payload || {};
            const { markerRef: markerRef_0, commentId: commentId, inlineCommentType: inlineCommentType } = inlineCommentRequestBody || {};
            if (accountId === currentUserId) return;
            const isReply = inlineCommentType === "REPLY";
            bb53: switch(event_0){
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
                    if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                        if (commentId) await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: "network-only"
                        });
                    } else await (0, $03oqz.handleAddNewCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef_0,
                        addNewCommentThreads: addNewCommentThreads
                    });
                    if (markerRef_0 && reopenParentComment) reopenParentComment({
                        threadKey: markerRef_0,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                    handleOnPublicationEvent("unresolve", markerRef_0);
                    break bb53;
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
                    {
                        handleOnPublicationEvent("resolve", markerRef_0);
                        if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                            if (commentId) (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: "network-only"
                            });
                        }
                        const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                        if (inlineResolveProperties && inlineText) updateRemovedCommentIdsMap({
                            threadKey: markerRef_0,
                            commentId: commentId,
                            commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                            isReply: isReply,
                            resolvedProperties: {
                                inlineResolveProperties: inlineResolveProperties,
                                inlineText: inlineText
                            },
                            commentType: (0, $8i27m.CommentType).INLINE
                        });
                        const { replies: t11 } = inlineCommentRequestBody;
                        const replies = t11 === undefined ? [] : t11;
                        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                            commentId,
                            ...replies
                        ]), "remove");
                        break bb53;
                    }
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentCreated:
                case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentCreated:
                case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
                    if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                        if (addCommentInCache && commentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: "network-only"
                            });
                            if (comment) addCommentInCache({
                                newComment: comment
                            });
                        }
                    } else if (isReply) await (0, $03oqz.handleAddedReplyInCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef_0,
                        commentId: commentId,
                        addReplyToCommentThread: addReplyToCommentThread,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        storedCommentData: storedCommentData,
                        setStoredCommentData: setStoredCommentData
                    });
                    else await (0, $03oqz.handleAddNewCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef_0,
                        addNewCommentThreads: addNewCommentThreads
                    });
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), "add");
                    handleOnPublicationEvent("create", markerRef_0);
                    break bb53;
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
                    updateRemovedCommentIdsMap({
                        threadKey: markerRef_0,
                        commentId: commentId,
                        isReply: isReply,
                        commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), "remove");
                    if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                        if (deleteCommentInCache && commentId) deleteCommentInCache({
                            commentId: commentId
                        });
                    }
                    if (isReply && markerRef_0 === selectedAnnotationId) (0, $03oqz.refreshCommentThread)(contentId, markerRef_0);
                    if (!isReply && (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux")) handleOnPublicationEvent("delete", markerRef_0);
                    break bb53;
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
                    if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                        if (commentId) (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: "network-only"
                        });
                    } else (0, $03oqz.handleEditedComment)({
                        contentId: contentId,
                        markerRef: markerRef_0,
                        commentId: commentId,
                        updateCommentBody: updateCommentBody
                    });
                    break bb53;
                default:
            }
        };
        $[12] = addCommentInCache;
        $[13] = addNewCommentThreads;
        $[14] = addReplyToCommentThread;
        $[15] = contentId;
        $[16] = currentUserId;
        $[17] = deleteCommentInCache;
        $[18] = handleOnPublicationEvent;
        $[19] = reopenParentComment;
        $[20] = selectedAnnotationId;
        $[21] = setStoredCommentData;
        $[22] = storedCommentData;
        $[23] = updateCommentBody;
        $[24] = updateRemovedCommentIdsMap;
        $[25] = updateUnreadCommentIDSet;
        $[26] = t10;
    } else t10 = $[26];
    const onPublicationEvent = t10;
    let t11;
    if ($[27] !== addSubscriber || $[28] !== contentId || $[29] !== onPublicationEvent || $[30] !== pubSubResourceType || $[31] !== setContentId || $[32] !== setContentType) {
        t11 = ()=>{
            if ((0, $9wGTI.fg)("cc_fps_migration_comments") && (0, $9wGTI.fg)("confluence_enable_subscriptions-context-provider")) {
                if (!setContentType || !setContentId || !addSubscriber) return;
                setContentType(pubSubResourceType);
                setContentId(contentId);
                const subscribers = [
                    {
                        subscriberId: "useEditorInlineCommentsPubSubInlineCommentResolved",
                        onSubscriptionData: onPublicationEvent,
                        delta: "inlineCommentResolved"
                    },
                    {
                        subscriberId: "useEditorInlineCommentsPubSubInlineCommentUnresolved",
                        onSubscriptionData: onPublicationEvent,
                        delta: "inlineCommentUnresolved"
                    },
                    {
                        subscriberId: "useEditorInlineCommentsPubSubInlineCommentCreated",
                        onSubscriptionData: onPublicationEvent,
                        delta: "inlineCommentCreated"
                    },
                    {
                        subscriberId: "useEditorInlineCommentsPubSubInlineCommentUpdated",
                        onSubscriptionData: onPublicationEvent,
                        delta: "inlineCommentUpdated"
                    },
                    {
                        subscriberId: "useEditorInlineCommentsPubSubEditorInlineCommentCreated",
                        onSubscriptionData: onPublicationEvent,
                        delta: "editorInlineCommentCreated"
                    }
                ];
                for (const subscriber of subscribers)subscriptions.current.push({
                    subscriberId: addSubscriber(subscriber),
                    delta: subscriber.delta
                });
                subscriptions.current.push({
                    delta: "inlineCommentDeleted",
                    subscriberId: addSubscriber({
                        subscriberId: "useEditorInlineCommentsPubSubInlineCommentDeleted",
                        onSubscriptionData: onPublicationEvent,
                        delta: "inlineCommentDeleted"
                    })
                });
            } else (0, $gRrX4.getPubSubClient)().then((client)=>{
                client.joinChannel(pubSubResourceType, contentId).finally(()=>{
                    client.subscribe((0, $7S9uM.eventToAvi)("resolved:inline_comment"), onPublicationEvent);
                    client.subscribe((0, $7S9uM.eventToAvi)("unresolved:inline_comment"), onPublicationEvent);
                    client.subscribe((0, $7S9uM.eventToAvi)("created:inline_comment"), onPublicationEvent);
                    client.subscribe((0, $7S9uM.eventToAvi)("created:editor_inline_comment"), onPublicationEvent);
                    client.subscribe((0, $7S9uM.eventToAvi)("updated:inline_comment"), onPublicationEvent);
                    client.subscribe((0, $7S9uM.eventToAvi)("deleted:inline_comment"), onPublicationEvent);
                }).catch($c13ad953d7aa53c9$var$_temp2);
            });
        };
        $[27] = addSubscriber;
        $[28] = contentId;
        $[29] = onPublicationEvent;
        $[30] = pubSubResourceType;
        $[31] = setContentId;
        $[32] = setContentType;
        $[33] = t11;
    } else t11 = $[33];
    const register = t11;
    let t12;
    if ($[34] !== contentId || $[35] !== onPublicationEvent || $[36] !== pubSubResourceType || $[37] !== removeSubscriber) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("cc_fps_migration_comments") && (0, $9wGTI.fg)("confluence_enable_subscriptions-context-provider")) for (const subscriber_0 of subscriptions.current)removeSubscriber?.(subscriber_0);
            else (0, $gRrX4.getPubSubClient)().then((client_0)=>{
                client_0.leaveChannel(pubSubResourceType, contentId);
                client_0.unsubscribe((0, $7S9uM.eventToAvi)("resolved:inline_comment"), onPublicationEvent);
                client_0.unsubscribe((0, $7S9uM.eventToAvi)("unresolved:inline_comment"), onPublicationEvent);
                client_0.unsubscribe((0, $7S9uM.eventToAvi)("created:inline_comment"), onPublicationEvent);
                client_0.unsubscribe((0, $7S9uM.eventToAvi)("created:editor_inline_comment"), onPublicationEvent);
                client_0.unsubscribe((0, $7S9uM.eventToAvi)("updated:inline_comment"), onPublicationEvent);
                client_0.unsubscribe((0, $7S9uM.eventToAvi)("deleted:inline_comment"), onPublicationEvent);
            });
        };
        $[34] = contentId;
        $[35] = onPublicationEvent;
        $[36] = pubSubResourceType;
        $[37] = removeSubscriber;
        $[38] = t12;
    } else t12 = $[38];
    const unregister = t12;
    let t13;
    if ($[39] !== onPublicationEvent || $[40] !== register || $[41] !== unregister) {
        t13 = {
            register: register,
            unregister: unregister,
            onPublicationEvent: onPublicationEvent
        };
        $[39] = onPublicationEvent;
        $[40] = register;
        $[41] = unregister;
        $[42] = t13;
    } else t13 = $[42];
    return t13;
} : ({ contentId: contentId, contentType: contentType, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache })=>{
    const pubSubResourceType = contentType || 'page';
    const subscriptions = (0, $42omo.useRef)([]);
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, updateCommentBody: updateCommentBody, reopenParentComment: reopenParentComment }] = (0, $8i27m.useCommentsData)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const orderedActiveAnnotationIdListRef = (0, $42omo.useRef)(orderedActiveAnnotationIdList);
    const { editorViewProps: editorViewProps } = (0, $cZa7r.useAnnotations)();
    const { setContentId: setContentId, setContentType: setContentType, addSubscriber: addSubscriber, removeSubscriber: removeSubscriber } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { annotations: annotations = [] } = editorViewProps || {};
    const selectedAnnotationId = annotations[0]?.id;
    (0, $42omo.useEffect)(()=>{
        orderedActiveAnnotationIdListRef.current = orderedActiveAnnotationIdList;
    }, [
        orderedActiveAnnotationIdList
    ]);
    const handleOnPublicationEvent = (0, $42omo.useCallback)((event, markerRef)=>{
        const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
        emitter.emit(event, markerRef);
        const annotationIds = orderedActiveAnnotationIdListRef.current.map((annotation)=>annotation.threadKey);
        if (triggerAnalyticsEvent) // Updates ordered list of unresolved inline comments based on ADF to account for real-time changes (collaborative editing)
        (0, $kDIns.getEditorResolvedState)({
            // the annotations won't already include the pubsub marker ref
            annotations: (0, $aHcFH.getSortedMarkerRefs)([
                ...annotationIds,
                markerRef
            ], 'edit'),
            pageId: contentId,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            updateUnresolvedInlineComment: updateUnresolvedInlineComment
        });
    }, [
        contentId,
        triggerAnalyticsEvent,
        updateUnresolvedInlineComment
    ]);
    const onPublicationEvent = (0, $42omo.useCallback)(async (event_0, payload)=>{
        if (!event_0) return;
        let inlineCommentRequestBody;
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) inlineCommentRequestBody = payload?.[event_0];
        else inlineCommentRequestBody = payload.inlineCommentRequestBody;
        const { accountId: accountId } = payload || {};
        const { markerRef: markerRef_0, commentId: commentId, inlineCommentType: inlineCommentType } = inlineCommentRequestBody || {};
        // Don't do anything when the current user performs an action
        if (accountId === currentUserId) return;
        const isReply = inlineCommentType === 'REPLY';
        switch(event_0){
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    await (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    });
                } else // We load resolved + active separately, so unless the user has visited the resolved tab, the comment thread won't be in the state
                // Hence the await here - as part of this function we update state
                await (0, $03oqz.handleAddNewCommentThread)({
                    contentId: contentId,
                    markerRef: markerRef_0,
                    addNewCommentThreads: addNewCommentThreads
                });
                // Remove from commentThreadsRemovedByOtherUsers when reopened
                if (markerRef_0 && reopenParentComment) reopenParentComment({
                    threadKey: markerRef_0,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
                // Call handleOnPublicationEvent after store updates are complete
                handleOnPublicationEvent('unresolve', markerRef_0);
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
                handleOnPublicationEvent('resolve', markerRef_0);
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    });
                }
                const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                if (inlineResolveProperties && inlineText) updateRemovedCommentIdsMap({
                    threadKey: markerRef_0,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                    isReply: isReply,
                    resolvedProperties: {
                        inlineResolveProperties: inlineResolveProperties,
                        inlineText: inlineText
                    },
                    commentType: (0, $8i27m.CommentType).INLINE
                });
                const { replies: replies = [] } = inlineCommentRequestBody;
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId,
                    ...replies
                ]), 'remove');
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentCreated:
            case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (addCommentInCache && commentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment
                        });
                    }
                } else if (isReply) await (0, $03oqz.handleAddedReplyInCommentThread)({
                    contentId: contentId,
                    markerRef: markerRef_0,
                    commentId: commentId,
                    addReplyToCommentThread: addReplyToCommentThread,
                    commentType: (0, $8i27m.CommentType).INLINE,
                    storedCommentData: storedCommentData,
                    setStoredCommentData: setStoredCommentData
                });
                else await (0, $03oqz.handleAddNewCommentThread)({
                    contentId: contentId,
                    markerRef: markerRef_0,
                    addNewCommentThreads: addNewCommentThreads
                });
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId
                ]), 'add');
                // Call handleOnPublicationEvent after store updates are complete
                handleOnPublicationEvent('create', markerRef_0);
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
                // both a parent comment and reply can be deleted
                updateRemovedCommentIdsMap({
                    threadKey: markerRef_0,
                    commentId: commentId,
                    isReply: isReply,
                    commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId
                ]), 'remove');
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (deleteCommentInCache && commentId) deleteCommentInCache({
                        commentId: commentId
                    });
                }
                // Always handle annotation logic
                // We update useCommentsData state for the full panel, but the standalone comment doesn't look at it, so keep in sync via the API
                if (isReply && markerRef_0 === selectedAnnotationId) (0, $03oqz.refreshCommentThread)(contentId, markerRef_0);
                if (!isReply && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) handleOnPublicationEvent('delete', markerRef_0);
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    });
                } else (0, $03oqz.handleEditedComment)({
                    contentId: contentId,
                    markerRef: markerRef_0,
                    commentId: commentId,
                    updateCommentBody: updateCommentBody
                });
                break;
            default:
                break;
        }
    }, [
        contentId,
        handleOnPublicationEvent,
        selectedAnnotationId,
        addNewCommentThreads,
        addReplyToCommentThread,
        updateRemovedCommentIdsMap,
        currentUserId,
        updateCommentBody,
        storedCommentData,
        setStoredCommentData,
        updateUnreadCommentIDSet,
        addCommentInCache,
        deleteCommentInCache,
        reopenParentComment
    ]);
    const register = (0, $42omo.useCallback)(()=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
            if (!setContentType || !setContentId || !addSubscriber) return;
            setContentType(pubSubResourceType);
            setContentId(contentId);
            const subscribers = [
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentResolved',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentResolved'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentUnresolved',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentUnresolved'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentCreated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentCreated'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentUpdated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentUpdated'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubEditorInlineCommentCreated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'editorInlineCommentCreated'
                }
            ];
            for (const subscriber of subscribers)subscriptions.current.push({
                subscriberId: addSubscriber(subscriber),
                delta: subscriber.delta
            });
            subscriptions.current.push({
                delta: 'inlineCommentDeleted',
                subscriberId: addSubscriber({
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentDeleted',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentDeleted'
                })
            });
        } else (0, $gRrX4.getPubSubClient)().then((client)=>{
            client.joinChannel(pubSubResourceType, contentId).finally(()=>{
                client.subscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('created:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), onPublicationEvent);
            }).catch((error)=>{
                throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error)}`);
            });
        });
    }, [
        setContentType,
        pubSubResourceType,
        setContentId,
        contentId,
        onPublicationEvent,
        subscriptions,
        addSubscriber
    ]);
    const unregister = (0, $42omo.useCallback)(()=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) for (const subscriber_0 of subscriptions.current)removeSubscriber?.(subscriber_0);
        else (0, $gRrX4.getPubSubClient)().then((client_0)=>{
            client_0.leaveChannel(pubSubResourceType, contentId);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('created:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), onPublicationEvent);
        });
    }, [
        contentId,
        onPublicationEvent,
        pubSubResourceType,
        removeSubscriber,
        subscriptions
    ]);
    return (0, $42omo.useMemo)(()=>({
            register: register,
            unregister: unregister,
            onPublicationEvent: onPublicationEvent
        }), [
        register,
        unregister,
        onPublicationEvent
    ]);
};
function $c13ad953d7aa53c9$var$_temp(annotation) {
    return annotation.threadKey;
}
function $c13ad953d7aa53c9$var$_temp2(error) {
    throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error)}`);
}


const $b50d68d67cedaa55$export$7d464c122ca911c0 = ({ contentId: contentId, contentType: contentType, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, isEnabled: isEnabled = true, isDocumentActive: isDocumentActive, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache })=>{
    const isRegistered = (0, $42omo.useRef)(false);
    const { register: register, unregister: unregister } = (0, $c13ad953d7aa53c9$export$7d464c122ca911c0)({
        contentId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: updateUnresolvedInlineComment,
        contentType: contentType,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    });
    (0, $42omo.useEffect)(()=>{
        if (isEnabled && !isRegistered.current) {
            register();
            isRegistered.current = true;
            return ()=>{
                unregister();
                isRegistered.current = false;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEnabled,
        register,
        unregister,
        isDocumentActive
    ]);
};
module.exports["useEditorInlineCommentsPubSub"] = $b50d68d67cedaa55$export$7d464c122ca911c0;

});

parcelRegister("btQhd", function(module, exports) {
/* EditorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $T1bCI = parcelRequire("T1bCI");


var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");


var $h3X17 = parcelRequire("h3X17");


var $inPa6 = parcelRequire("inPa6");


var $iRRvH = parcelRequire("iRRvH");


var $5vi32 = parcelRequire("5vi32");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9wGTI = parcelRequire("9wGTI");


var $jxpvN = parcelRequire("jxpvN");


var $hrAmX = parcelRequire("hrAmX");


var $7aRa9 = parcelRequire("7aRa9");


var $6MSEP = parcelRequire("6MSEP");


var $dPJCf = parcelRequire("dPJCf");


var $6jB9o = parcelRequire("6jB9o");


var $1mHQU = parcelRequire("1mHQU");

/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */ 



var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");




var $1944a553ea5f1b71$export$b0df660525fc873b = /*#__PURE__*/ function(NATIVE_COLLAB_ERROR_REASONS) {
    // Native collab errors propagate from Confluence BE in S2S request to permission refresh and then to websocket via atlassian-frontend/src/packages/editor/collab-provider/src/error-code-mapper.ts
    NATIVE_COLLAB_ERROR_REASONS["RESOURCE_DELETED"] = "RESOURCE_DELETED";
    return NATIVE_COLLAB_ERROR_REASONS;
}({});
const $1944a553ea5f1b71$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    recoveryErrorTitle: {
        id: "editor-flags.error.recovery.title",
        defaultMessage: "Something went wrong while loading the editor"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    recoveryErrorBody: {
        id: "editor-flags.error.recovery.body",
        defaultMessage: "Your changes are safe. Please refresh and try again."
    },
    siteMaintenanceTitle: {
        id: "editor-flags.error.tenant.suspended.title",
        defaultMessage: "You can\u2019t edit this content right now"
    },
    siteMaintenanceDescription: {
        id: "editor-flags.error.tenant.suspended.description",
        defaultMessage: "Your Atlassian Cloud site is unavailable due to scheduled maintenance."
    },
    permissionRemovedTitle: {
        id: "fabric.editor.permission.removed.title",
        defaultMessage: "We can\u2019t show this content"
    },
    permissionRemovedDescription: {
        id: "fabric.editor.permission.removed.description",
        defaultMessage: "The permissions for this content were changed. Contact an admin for help."
    },
    pageRemovedTitle: {
        id: "fabric.editor.page.removed.title",
        defaultMessage: "This page was recently archived or deleted"
    },
    pageRemovedDescription: {
        id: "fabric.editor.page.removed.description",
        defaultMessage: "Please refresh now."
    },
    genericServerErrorTitle: {
        id: "error.server-error.title",
        defaultMessage: "Something went wrong"
    },
    genericServerErrorBody: {
        id: "error.server-error.body",
        defaultMessage: "Please try again later."
    }
});
/**
 * Currently collab service errors are handled based on error status code, in the future we may want finer granularity
 * and use the error message to provide further information in flag description. See also EditorWrapper.tsx & EditorFlags.tsx
 */ const $1944a553ea5f1b71$var$collabEditErrorFlagContent = (formatMessage, statusCode, reason)=>{
    switch(statusCode){
        case 403:
            if (reason === "RESOURCE_DELETED") return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedDescription)
            };
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedDescription)
            };
        case 423:
            // tenant suspended / maintenance
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceDescription)
            };
        case 500:
            // Generic error for unrecoverable 500s from Collab Service...
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorBody)
            };
        default:
            break;
    }
};
const $1944a553ea5f1b71$var$heartbeatErrorFlagContent = (formatMessage, reason)=>{
    switch(reason){
        case 'unauthorised':
        case 'UNAUTHORIZED':
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedDescription)
            };
        case 'tenant-unavailable':
            return {
                title: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceTitle),
                description: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceDescription)
            };
        default:
            break;
    }
};
const $1944a553ea5f1b71$var$confluenceErrorFlagContent = (formatMessage, statusCode)=>{
    if (!statusCode) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.genericServerErrorBody)
    };
    if (statusCode === 403) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.permissionRemovedDescription)
    };
    else if (statusCode === 404) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.pageRemovedDescription)
    };
    else if (statusCode === 503) return {
        title: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceTitle),
        description: formatMessage($1944a553ea5f1b71$var$i18n.siteMaintenanceDescription)
    };
};
const $1944a553ea5f1b71$export$37cc9ec36ef290a5 = ({ flags: flags, collabEditError: collabEditError, collabRecoveryError: collabRecoveryError, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if (collabEditError) {
            const flagContent = $1944a553ea5f1b71$var$collabEditErrorFlagContent(intl.formatMessage, 'status' in collabEditError ? collabEditError.status : undefined, 'reason' in collabEditError ? collabEditError.reason : undefined);
            if (flagContent) flags.showErrorFlag({
                ...flagContent
            });
        } // Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabRecoveryError) flags.showErrorFlag({
            title: intl.formatMessage($1944a553ea5f1b71$var$i18n.recoveryErrorTitle),
            description: intl.formatMessage($1944a553ea5f1b71$var$i18n.recoveryErrorBody)
        });
         // Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabRecoveryError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (heartbeatError) {
            const flagContent = $1944a553ea5f1b71$var$heartbeatErrorFlagContent(intl.formatMessage, 'reason' in heartbeatError ? heartbeatError.reason : undefined);
            if (flagContent) flags.showErrorFlag({
                ...flagContent
            });
        } // Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        heartbeatError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (saveDraftError) {
            const flagContent = $1944a553ea5f1b71$var$confluenceErrorFlagContent(intl.formatMessage, saveDraftError.statusCode);
            if (flagContent) flags.showErrorFlag({
                ...flagContent
            });
        } // You guessed it! .....Don't depend on `flags` since its updates will cause infinite spam
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        saveDraftError
    ]);
    // Cleanup on component unmount
    (0, $42omo.useEffect)(()=>()=>void flags.hideAllFlags(), [
        flags
    ]);
    return null;
};
const $1944a553ea5f1b71$export$23602cd239c801ed = (0, $7aRa9.withFlags)($1944a553ea5f1b71$export$37cc9ec36ef290a5);



var $601vk = parcelRequire("601vk");


var $wtSEP = parcelRequire("wtSEP");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4PPzL = parcelRequire("4PPzL");


var $9Z1sw = parcelRequire("9Z1sw");


var $eSLr0 = parcelRequire("eSLr0");


var $sLZsl = parcelRequire("sLZsl");


var $jmjWc = parcelRequire("jmjWc");


const $0c186b876cfe191c$export$5960959cfc832bcd = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EcrVg",
    loader: async ()=>(await (parcelRequire("epT4q"))).EditorConversionModal,
    name: 'EditorConversionModal'
});



var $S6mif = parcelRequire("S6mif");


var $5MyXJ = parcelRequire("5MyXJ");


var $bQm3c = parcelRequire("bQm3c");


var $eSUdr = parcelRequire("eSUdr");

const $f7eb9f600e97ba76$export$1c211db4e67cf500 = (0, $eSUdr.gql)`query PageTitleQuery($contentId:ID!){singleContent(id:$contentId){id title}}`;



var $hp2SH = parcelRequire("hp2SH");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $iVU5h = parcelRequire("iVU5h");


var $iSXh4 = parcelRequire("iSXh4");


var $hNtOj = parcelRequire("hNtOj");


var $bUSKZ = parcelRequire("bUSKZ");











var $7zgzO = parcelRequire("7zgzO");


var $e9owJ = parcelRequire("e9owJ");




const $1d20d8840d947140$export$d8ddb957fd6cf218 = (0, $eSUdr.default)`query ContentSpaceKeyQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id space{id key alias}}}}`;


const $99aa1354571330dd$export$486cb94e63be330f = ({ contentType: contentType })=>{
    const { match: match, replace: replace, toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { contentId: contentId, spaceKey: spaceKeyFromUrl } = match?.params ?? {};
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)({
        contentId: contentId,
        contentType: contentType,
        source: 'editPageScreen',
        subject: 'editor',
        collabService: 'ncs'
    });
    // Replaces the URL to match the given space key
    const changeUrl = (0, $42omo.useCallback)((spaceKey)=>{
        // Only changing the space key
        const params = {
            ...match?.params,
            query: match?.query,
            spaceKey: spaceKey
        };
        const url = toUrl(match?.name, params);
        if (url !== null) replace(url);
    }, [
        replace,
        toUrl,
        match
    ]);
    // Changes the URL if the new space key from the move event is different from the current
    const onMoveSubscriptionEvent = (0, $42omo.useCallback)((_eventName, response)=>{
        const newSpaceAlias = response?.pageMoved?.newSpaceAlias ?? null;
        if (newSpaceAlias !== null && newSpaceAlias?.toLowerCase() !== spaceKeyFromUrl?.toLowerCase()) changeUrl(newSpaceAlias);
        // Fire analytics to track when the page or blog was moved
        const eventName = contentType === 'page' ? 'pageMoved' : 'blogMoved';
        triggerAnalyticsEvent(eventName, {
            editorType: 'next',
            ...response
        });
    }, [
        changeUrl,
        contentType,
        spaceKeyFromUrl,
        triggerAnalyticsEvent
    ]);
    // Handles the case where the page is moved while the user is editing it
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'UseSpaceKeyWatcherSubscription',
        delta: 'pageMoved',
        onDataReceived: onMoveSubscriptionEvent
    });
    // Handles the case where the user returns to a bookmarked page which has since been moved
    (0, $42omo.useEffect)(()=>{
        const fetchSpaceKey = async ()=>{
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const { data: data } = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $1d20d8840d947140$export$d8ddb957fd6cf218),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: 'network-only'
            });
            const contentSpaceKeyAsKey = data?.content?.nodes?.[0]?.space?.key ?? null;
            const contentSpaceAliasAsKey = data?.content?.nodes?.[0]?.space?.alias ?? null;
            const contentSpaceKey = contentSpaceAliasAsKey || contentSpaceKeyAsKey;
            if (contentSpaceKey !== null && contentSpaceKey !== spaceKeyFromUrl) changeUrl(contentSpaceKey);
        };
        if (contentId) fetchSpaceKey();
    }, [
        contentId,
        changeUrl,
        spaceKeyFromUrl
    ]);
};



var $2tHI8 = parcelRequire("2tHI8");





var $gtD4K = parcelRequire("gtD4K");


var $6mKj3 = parcelRequire("6mKj3");





var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");










var $aJv6Q = parcelRequire("aJv6Q");


var $3IBnw = parcelRequire("3IBnw");











var $4U6ec = parcelRequire("4U6ec");

/**
 * @generated SignedSource<<b225791bbc02485a648a3cb35603acdb>>
 * @relayHash 3bebc9b916816a4421a88a5541e30086
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7a1aa7636dab60636aa748a13ec4c88b1f1170c4a67b1f74da99ad0e09e4ce8
const $d42c0607fc0e2a3a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DraftContentProperties",
                                    "kind": "LinkedField",
                                    "name": "draft",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "autoConvertedDate"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAutoConvertedRecentlyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAutoConvertedRecentlyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3bebc9b916816a4421a88a5541e30086",
            "id": "c7a1aa7636dab60636aa748a13ec4c88b1f1170c4a67b1f74da99ad0e09e4ce8",
            "metadata": {},
            "name": "useIsAutoConvertedRecentlyQuery",
            "operationKind": "query",
            "text": "query useIsAutoConvertedRecentlyQuery($contentId:ID!){content(id:$contentId){nodes{id,properties(key:\"editor\"){nodes{value}},metadata{frontend{fabricEditorSupported}},contentProperties{draft{autoConvertedDate}}}}}"
        }
    };
}();
$d42c0607fc0e2a3a$var$node.hash = "bd10bb6670b064c3529095e127e8cdf2";
var $d42c0607fc0e2a3a$export$2e2bcd8739ae039 = $d42c0607fc0e2a3a$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $9d4f4069312c3141$export$43dbb334710faaa0 = (0, $d42c0607fc0e2a3a$export$2e2bcd8739ae039);
const $9d4f4069312c3141$export$1136bf1e7d4859ac = ({ contentId: contentId })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($9d4f4069312c3141$export$43dbb334710faaa0, {
        variables: {
            contentId: contentId
        }
    });
    const node = data?.content?.nodes?.[0];
    // isFabricEditor: Is this page persisted as a v2 Fabric page, or a legacy page (v1/null)?
    const isFabricEditor = node?.properties?.nodes?.[0]?.value === '"v2"';
    // isFabricEditorSupported: Is this page eligible for conversion from legacy to Fabric?
    const isFabricEditorSupported = !!node?.metadata?.frontend?.fabricEditorSupported;
    // isAutoConverted: A page is auto-converted if it is not persisted as Fabric, and is conversion eligible.
    const isAutoConverted = !isFabricEditor && isFabricEditorSupported;
    // isMarkedAutoConverted: Does this page already have the autoConvertedDate content property? (i.e. has this auto-converted page been previously visited?)
    const isMarkedAutoConverted = !!node?.contentProperties?.draft?.autoConvertedDate;
    return {
        loading: loading,
        error: error,
        isAutoConverted: isAutoConverted,
        isMarkedAutoConverted: isMarkedAutoConverted
    };
};


/**
 * @generated SignedSource<<2d796846479ff9c77d3dcd146c822fe7>>
 * @relayHash a88f8ef230b3d1f68cdbdbbb6d77d943
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db06bf7f6c39ffc11c383a55a4d313a8051acfca05b47e376d7108a2ac6d4258
const $0ec7676069805861$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useMarkAutoConvertedDateMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceCreateAutoConvertedDatePayload",
                    "kind": "LinkedField",
                    "name": "confluence_createAutoConvertedDate",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useMarkAutoConvertedDateMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceCreateAutoConvertedDatePayload",
                    "kind": "LinkedField",
                    "name": "confluence_createAutoConvertedDate",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a88f8ef230b3d1f68cdbdbbb6d77d943",
            "id": "db06bf7f6c39ffc11c383a55a4d313a8051acfca05b47e376d7108a2ac6d4258",
            "metadata": {},
            "name": "useMarkAutoConvertedDateMutation",
            "operationKind": "mutation",
            "text": "mutation useMarkAutoConvertedDateMutation($input:ConfluenceCreateAutoConvertedDateInput!,$cloudId:ID!){confluence_createAutoConvertedDate(cloudId:$cloudId,input:$input){success,errors{extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}},message}}}"
        }
    };
}();
$0ec7676069805861$var$node.hash = "b462648a057e8cb8c786e1b5e6926d57";
var $0ec7676069805861$export$2e2bcd8739ae039 = $0ec7676069805861$var$node;









var $308Wd = parcelRequire("308Wd");





var $1NBp8 = parcelRequire("1NBp8");


const $d332ea2ab10997ab$export$7bc4789aad42c5 = ({ cloudId: cloudId, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Mutation which "marks" a page by adding the autoConvertedDate content property to the page
    const [markAutoConvertedDateMutation] = (0, $308Wd.useMutationInterop)((0, $0ec7676069805861$export$2e2bcd8739ae039), {
        onError: (err)=>{
            // If an error occurred, track it with an analytics event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'markAutoConvertedDate',
                    source: (0, $1NBp8.EDIT_PAGE_V2).name,
                    attributes: {
                        contentId: contentId,
                        isGQLError: true,
                        message: err.message
                    }
                }
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        },
        refetchQueries: ()=>[
                {
                    // Refetch query data for whether page is marked as auto-converted
                    query: (0, $9d4f4069312c3141$export$43dbb334710faaa0),
                    variables: {
                        contentId: contentId
                    }
                }
            ]
    });
    const markAutoConvertedDate = (0, $42omo.useCallback)(async ()=>{
        // Mark the page as auto-converted by setting the autoConvertedDate content property
        const { data: data } = await markAutoConvertedDateMutation({
            variables: {
                cloudId: cloudId,
                input: {
                    contentId: contentId
                }
            }
        });
        const errors = data?.confluence_createAutoConvertedDate?.errors;
        // If an error occurred, track it with an analytics event
        if (errors?.length) errors.forEach((err)=>createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'markAutoConvertedDate',
                    source: (0, $1NBp8.EDIT_PAGE_V2).name,
                    attributes: {
                        contentId: contentId,
                        isGQLError: false,
                        message: err.message
                    }
                }
            }).fire());
    }, [
        cloudId,
        contentId,
        createAnalyticsEvent,
        markAutoConvertedDateMutation
    ]);
    return {
        markAutoConvertedDate: markAutoConvertedDate
    };
};


const $87ee69f0834f1b27$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    pageHasBeenConvertedTitle: {
        id: "editor-features.page-has-been-converted-title",
        defaultMessage: "Page has been converted"
    },
    pageHasBeenConvertedDescription: {
        id: "editor-features.page-has-been-converted-description",
        defaultMessage: "This page has been converted to the new editing experience"
    },
    pageHasBeenConvertedLearnMore: {
        id: "editor-features.page-has-been-converted-learn-more-link",
        defaultMessage: "Learn more"
    }
});
const $87ee69f0834f1b27$export$91195e10eb787117 = ()=>{
    window.open((0, $4U6ec.learnMoreURL), '_blank');
};
const $87ee69f0834f1b27$var$FlagComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ flags: flags, onShowFlag: onShowFlag })=>{
    const showFlag = (0, $42omo.useRef)(true);
    // Show the flag and trigger any side effects once
    if (showFlag) {
        flags.showInfoFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $87ee69f0834f1b27$export$a7357cdd1f0b0168.pageHasBeenConvertedTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $87ee69f0834f1b27$export$a7357cdd1f0b0168.pageHasBeenConvertedDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $87ee69f0834f1b27$export$a7357cdd1f0b0168.pageHasBeenConvertedLearnMore),
                    onClick: $87ee69f0834f1b27$export$91195e10eb787117
                }
            ],
            // Auto-dismiss the flag after 8 seconds (AtlasKit AutoDismissFlag default dismiss delay)
            isAutoDismiss: true
        });
        onShowFlag();
        showFlag.current = false;
    }
    return null;
});
const $87ee69f0834f1b27$export$111652a70d302bfa = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
})(({ contentId: contentId, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // Get relevant auto-conversion data
    const { loading: loading, error: error, isAutoConverted: isAutoConverted, isMarkedAutoConverted: isMarkedAutoConverted } = (0, $9d4f4069312c3141$export$1136bf1e7d4859ac)({
        contentId: contentId
    });
    // Determine if current user is the first one to interact with an auto-converted legacy page
    const didAutoConversionRecently = !loading && !error && isAutoConverted && !isMarkedAutoConverted;
    // This key is set previously when a user manually converts a page (i.e. clicks "Convert page")
    const didManualConversionRecently = (0, $42omo.useMemo)(()=>(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).PAGE_JUST_CONVERTED) === contentId, [
        contentId
    ]);
    // Mutation to mark auto-converted page with autoConvertedDate content property
    const { markAutoConvertedDate: markAutoConvertedDate } = (0, $d332ea2ab10997ab$export$7bc4789aad42c5)({
        cloudId: cloudId,
        contentId: contentId
    });
    const handleShowFlagManualConversion = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).PAGE_JUST_CONVERTED);
    }, []);
    const handleShowFlagAutoConversion = (0, $42omo.useCallback)(()=>{
        markAutoConvertedDate();
    }, [
        markAutoConvertedDate
    ]);
    if (didManualConversionRecently) // In the case of a recent manual conversion, we want to:
    // (1) Show the flag.
    // (2) Clear local storage since the manual conversion has completed and the user has received visual confirmation.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ee69f0834f1b27$var$FlagComponent, {
        flags: flags,
        onShowFlag: handleShowFlagManualConversion
    });
    else if (didAutoConversionRecently) // In the case of being the first visitor of an auto-converted page, we want to:
    // (1) Show the flag.
    // (2) Mark the page with an auto-conversion timestamp indicating this page has been visited. Subsequent page visits will not trigger the flag.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87ee69f0834f1b27$var$FlagComponent, {
        flags: flags,
        onShowFlag: handleShowFlagAutoConversion
    });
    return null;
});


// Note: Old component which shows the success flag only after a successful manual conversion; being phased out in favor of MigrationSuccessFlagComponentV2
const $9bece82eecc4ba59$var$MigrationSuccessFlagComponent = ({ contentId: contentId, flags: flags })=>{
    // We only want to show the flag once (we don't want to re-render and show the flag again)
    const didShowFlag = (0, $42omo.useRef)(false);
    // This key is set previously when a user manually converts a page (i.e. clicks "Convert page")
    const didManualConversionRecently = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).PAGE_JUST_CONVERTED) === contentId;
    // We want to clear the previously set key since we only want to show the flag when the user first lands in the Fabric editor
    const onClose = ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).PAGE_JUST_CONVERTED);
    const shouldShowFlag = (0, $42omo.useMemo)(()=>didManualConversionRecently && !!flags, [
        didManualConversionRecently,
        flags
    ]);
    if (shouldShowFlag && !didShowFlag.current) {
        didShowFlag.current = true;
        flags.showInfoFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $87ee69f0834f1b27$export$a7357cdd1f0b0168).pageHasBeenConvertedTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $87ee69f0834f1b27$export$a7357cdd1f0b0168).pageHasBeenConvertedDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $87ee69f0834f1b27$export$a7357cdd1f0b0168).pageHasBeenConvertedLearnMore),
                    onClick: (0, $87ee69f0834f1b27$export$91195e10eb787117)
                }
            ],
            // Auto-dismiss the flag after 8 seconds (AtlasKit AutoDismissFlag default dismiss delay)
            isAutoDismiss: true,
            onClose: onClose
        });
    }
    return null;
};
const $9bece82eecc4ba59$var$MigrationSuccessFlagComponentSwitch = (props)=>(0, $6mKj3.expValEquals)('confluence_auto_conversion_success_flag', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $87ee69f0834f1b27$export$111652a70d302bfa), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9bece82eecc4ba59$var$MigrationSuccessFlagComponent, props);
const $9bece82eecc4ba59$export$bc6e366e749c654a = (0, $7aRa9.withFlags)($9bece82eecc4ba59$var$MigrationSuccessFlagComponentSwitch);








var $gmMgo = parcelRequire("gmMgo");


var $2Nwuj = parcelRequire("2Nwuj");


var $iXCQx = parcelRequire("iXCQx");


var $lcuos = parcelRequire("lcuos");


var $eGqQQ = parcelRequire("eGqQQ");




















var $6fil2 = parcelRequire("6fil2");


var $5ZqQS = parcelRequire("5ZqQS");




const $2bc4ee56414e021f$export$d38c70a792a3108d = (0, $eSUdr.default)`query ContentAttachmentsQuery($contentId:ID!$status:[String]=["current"]){content(id:$contentId status:$status){edges{node{id attachments{nodes{id title extensions{key value}}}}}}}`;


const $3e63cfb29051b1a8$var$i18n = (0, $cgtv4.defineMessages)({
    sameFileNameTitle: {
        id: "editor-features.same.file.name.title",
        defaultMessage: "\u201C{file}\u201D already exists"
    },
    sameFileNameDescription: {
        id: "editor-features.same.file.name.description",
        defaultMessage: "The file you chose has the same name as an existing attachment, and the new one will replace the existing one."
    },
    sameFileNameLearnMore: {
        id: "editor-features.same.file.name.learn.more",
        defaultMessage: "Learn more about attachments."
    }
});
const $3e63cfb29051b1a8$var$ATTACHMENTS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/manage-uploaded-files/';
const $3e63cfb29051b1a8$var$SameFileNameWarningFlagComponent = ({ editorActions: editorActions, flags: flags, contentId: contentId, intl: intl })=>{
    // [file id]: file name
    const attachmentsMapRef = (0, $42omo.useRef)({});
    /**
   * parses the editor adf to get media nodes
   * @returns mediaNodes[]
   */ const getMediaNodesFromAdf = (0, $42omo.useCallback)(async ()=>{
        const adf = await editorActions.getValue();
        const mediaNodes = (0, $lcuos.filter)(adf, (node)=>node.type === 'media' && !!node?.attrs?.['collection'] && node.attrs?.type !== 'external');
        return mediaNodes;
    }, [
        editorActions
    ]);
    /**
   * sets a map of attachments on the content
   */ const getAttachmentsMap = (0, $42omo.useCallback)(async ()=>{
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $2bc4ee56414e021f$export$d38c70a792a3108d),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'draft'
                ]
            },
            fetchPolicy: 'network-only' // should get the latest ids
        }).catch((e)=>{
            if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
            return {
                data: null
            };
        });
        if (data === null) return;
        const attachmentsMap = data.content?.edges?.[0]?.node?.attachments?.nodes?.reduce((acc, curr)=>{
            const fileId = curr?.extensions?.find((i)=>i?.key === 'fileId')?.value;
            if (curr?.title && fileId) acc[fileId] = curr.title;
            return acc;
        }, {}) || {};
        Object.assign(attachmentsMapRef.current, attachmentsMap);
    }, [
        contentId
    ]);
    /**
   * @param filename
   */ const showSameFileNameFlag = (0, $42omo.useCallback)((filename)=>{
        flags.showWarningFlag({
            id: `file-with-same-name-${filename}`,
            title: intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameTitle, {
                file: filename
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "p"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameDescription), "\xa0", (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: $3e63cfb29051b1a8$var$ATTACHMENTS_LINK,
                target: "_blank"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameLearnMore)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: $3e63cfb29051b1a8$var$ATTACHMENTS_LINK,
                target: "_blank"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameLearnMore)))
        });
    }, [
        flags,
        intl
    ]);
    /**
   * globalMediaEventEmitter callback, compares uploaded file name to file names on the editor
   * @param uploadedFileDetails parameter from globalMediaEventEmitter
   */ const checkForDuplicateFileNames = (0, $42omo.useCallback)(async (uploadedFileDetails)=>{
        const { name: uploadedFileName, id: uploadedFileId } = uploadedFileDetails;
        const mediaNodes = await getMediaNodesFromAdf();
        for (const mediaNode of mediaNodes){
            const mediaNodeFileId = mediaNode?.attrs?.id;
            // no id and do not check self
            if (!mediaNodeFileId || mediaNodeFileId === uploadedFileId) continue;
            if (attachmentsMapRef.current[mediaNodeFileId] === uploadedFileName) {
                showSameFileNameFlag(uploadedFileName);
                break;
            }
        }
        attachmentsMapRef.current[uploadedFileId] = uploadedFileName;
    }, [
        getMediaNodesFromAdf,
        showSameFileNameFlag
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $eGqQQ.globalMediaEventEmitter).on('file-added', checkForDuplicateFileNames);
        return ()=>{
            (0, $eGqQQ.globalMediaEventEmitter).off('file-added', checkForDuplicateFileNames);
        };
    }, [
        checkForDuplicateFileNames
    ]);
    (0, $42omo.useEffect)(()=>{
        getAttachmentsMap();
    }, [
        getAttachmentsMap
    ]);
    return null;
};
const $3e63cfb29051b1a8$export$cf6bace5e57a00db = (0, $7aRa9.withFlags)((0, $gmMgo.default)($3e63cfb29051b1a8$var$SameFileNameWarningFlagComponent));


const $f5a9a69398726f05$var$HEARTBEAT_ERROR_FLAGS = [
    'tenant-unavailable',
    'unauthorised',
    'UNAUTHORIZED'
];
const $f5a9a69398726f05$var$EditorSuccessFlags = (0, $7aRa9.withFlags)((0, $601vk.EditorFlags)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a9a69398726f05$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bannerHeight: bannerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kn4d69": (0, $7sObp.default)(__cmplp.bannerHeight, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.bannerHeight > 0 ? "_4t3i2ld4" : "_4t3i1kxc",
            __cmplp.className
        ])
    });
});
const $f5a9a69398726f05$var$WithPanels = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $f5a9a69398726f05$var$PanelWrapper = ({ showPanel: showPanel, children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, children);
};
/* eslint-enable @typescript-eslint/no-unused-vars */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a9a69398726f05$var$Panel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $f5a9a69398726f05$var$PanelWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1o9zidpf _2lx21bp4",
            __cmplp?.showPanel ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $f5a9a69398726f05$var$getFlagData = (0, $2XqLN.default)((flagData)=>flagData, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $f5a9a69398726f05$export$c0ee4c2a5005a714 = ({ attribution: attribution, forceDisableEditor: forceDisableEditor, collabEditState: collabEditState, contentType: contentType, contentId: contentId, children: children, isUnpublishedDraft: isUnpublishedDraft, editorActions: editorActions, heartbeatError: heartbeatError, stopHeartbeatCallback: stopHeartbeatCallback, saveDraftError: saveDraftError, isLivePage: isLivePage, editorDisabled: editorDisabled })=>{
    const { includeTopNav: includeTopNav } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { collabEditInitialized: collabEditInitialized, collabEditError: collabEditError, collabRecoveryError: collabRecoveryError } = collabEditState;
    const [showCreateFromExtensionFlag, setShowCreateFromExtensionFlag] = (0, $42omo.useState)({
        showFlag: false,
        flagData: undefined
    });
    const [showRestoreSuccessFlag, setShowRestoreSuccessFlag] = (0, $42omo.useState)(false);
    const [blogifyConversionSuccess, setBlogifyConversionSuccess] = (0, $42omo.useState)({
        showFlag: false,
        flagData: undefined
    });
    const [heartbeatErrorFlag, setHeartbeatErrorFlag] = (0, $42omo.useState)({
        showFlag: false,
        heartbeatError: undefined
    });
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const previousHasSaveDraftError = (0, $42omo.useRef)(false);
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    // Analytics
    const migratedRecently = (0, $bUSKZ.useMigratedRecently)(contentId);
    // track publish experience in page migration
    // copied from ContentEditorBindingsComponent
    if (migratedRecently) experienceTracker.start({
        name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE),
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH
    });
    // Show a draft create success flag if this draft was created from the create page extension
    (0, $42omo.useEffect)(()=>{
        // Ensure editor is ready
        if (collabEditInitialized && !editorDisabled) {
            const parentContentId = (0, $6jB9o.getParentContentId)();
            if (parentContentId) {
                // Get the parent page title & show a draft create success flag
                let flagTimeout;
                // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                (0, $hp2SH.getApolloClient)().query({
                    query: (0, $f7eb9f600e97ba76$export$1c211db4e67cf500),
                    variables: {
                        contentId: parentContentId
                    }
                }).then((result)=>{
                    const parentTitle = result.data?.singleContent?.title;
                    flagTimeout = setTimeout(()=>{
                        setShowCreateFromExtensionFlag({
                            showFlag: true,
                            flagData: {
                                parentTitle: parentTitle,
                                parentContentId: parentContentId
                            }
                        });
                    }, 1000);
                }).catch((e)=>{
                    if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $95rLf.isExpectedApolloError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                });
                return ()=>{
                    clearTimeout(flagTimeout);
                };
            }
        }
    }, [
        collabEditInitialized,
        editorDisabled
    ]);
    const showBlogifyConversionSuccessFlag = blogifyConversionSuccess.showFlag;
    const blogifyConversionSuccessFlagData = blogifyConversionSuccess.flagData;
    const handleRestore = (0, $42omo.useCallback)((_delta, response)=>{
        const { trigger: trigger } = response?.pageUpdated || {};
        const { accountId: accountId } = response || {};
        if (trigger === 'restore') // Show this flag only if the same user triggered the restore
        // Otherwise, useUpdateEvent handles when a different user restores
        return !showRestoreSuccessFlag && userId === accountId && setShowRestoreSuccessFlag(true);
        return false;
    }, [
        showRestoreSuccessFlag,
        userId
    ]);
    const onBlogifySubscriptionEvent = (0, $42omo.useCallback)((_eventName, response)=>{
        // force disable NCS editor whenever page is converted to blogpost
        forceDisableEditor && forceDisableEditor(true);
        !showBlogifyConversionSuccessFlag && response?.pageBlogified && setBlogifyConversionSuccess({
            showFlag: true,
            flagData: response?.pageBlogified
        });
    }, [
        forceDisableEditor,
        showBlogifyConversionSuccessFlag
    ]);
    /**
   * To ensure that the editor is the correct height and doesn't have double scrollbars,
   */ const panelHeight = (0, $2tHI8.useGeneralWebPanelHeight)();
    (0, $42omo.useEffect)(()=>{
        if (heartbeatError) {
            if (heartbeatError.reason === 'tenant-unavailable') forceDisableEditor(true);
            else if ((0, $5MyXJ.isPermissionError)(heartbeatError)) stopHeartbeatCallback();
            if (heartbeatErrorFlag.heartbeatError?.reason !== heartbeatError.reason) // Only update error flag data if error is different
            setHeartbeatErrorFlag({
                showFlag: $f5a9a69398726f05$var$HEARTBEAT_ERROR_FLAGS.includes(heartbeatError.reason),
                heartbeatError: heartbeatError
            });
        }
    // exclude heartbeatErrorFlag.heartbeatError?.reason from dep list to prevent firing twice in a row
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        heartbeatError,
        forceDisableEditor,
        stopHeartbeatCallback
    ]);
    const { isAMN: isAMN, isRecurringParent: isRecurringParent } = (0, $iSXh4.useAutomatedMeetingNotesPageProperties)(contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage && isAMN) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editAMNPage',
                attributes: {
                    isRecurringParent: isRecurringParent,
                    referralSource: (0, $iVU5h.getAMNReferralSourceFromQueryParam)()
                }
            }
        }).fire();
    }, [
        contentId,
        isAMN,
        isRecurringParent,
        createAnalyticsEvent,
        isLivePage
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'EditorWrapperSubscriptionPageRestore',
        onDataReceived: handleRestore,
        delta: 'pageUpdated'
    });
    // GraphQL subscription for page blogified event
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'EditorWrapperSubscription',
        delta: 'pageBlogified',
        skip: // only listen for blogify events on pages
        contentType === 'blogpost',
        onDataReceived: onBlogifySubscriptionEvent
    });
    // Update the URL of the draft with new space key
    // 1. when another users move the page to different space
    // 2. when user returns to a bookmarked page which has since been moved
    (0, $99aa1354571330dd$export$486cb94e63be330f)({
        contentType: contentType
    });
    (0, $42omo.useEffect)(()=>{
        // Disable editor when saveDraftError exists, re-enable when error is reset
        if (saveDraftError) {
            forceDisableEditor(true);
            previousHasSaveDraftError.current = true;
        }
        if (saveDraftError === null && previousHasSaveDraftError.current === true) {
            // saveDraftError gets set to null explicitely when reset
            forceDisableEditor(false);
            previousHasSaveDraftError.current = false;
        }
    }, [
        saveDraftError,
        forceDisableEditor
    ]);
    if (collabRecoveryError) {
        // Collab Reset mutation can return 403 or 404 directly from Confluence upon editor loading (i.e. perms/page deleted hasn't changed during editing session, so no flag)
        if (collabRecoveryError instanceof (0, $S6mif.CollabRecoveryErrorType) && collabRecoveryError.status === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        });
        else if (collabRecoveryError instanceof (0, $S6mif.CollabRecoveryErrorType) && collabRecoveryError.status === 404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    }
    const isResourceDeletedOrArchived = collabEditError && 'reason' in collabEditError && collabEditError.reason === (0, $1944a553ea5f1b71$export$b0df660525fc873b).RESOURCE_DELETED;
    if (collabEditError?.status === 403) {
        // The collab service has emitted an error.
        // Cases for the 403:
        //  (1) on initial editor load when the collab provider is not initialized
        //  (2) user's permissions are revoked during the editing session.
        //  (3) page was deleted or archived: if this is the case, reason will be NATIVE_COLLAB_ERROR_REASONS.RESOURCE_DELETED
        // Most of the time when a 403 occurs, we want to kick the user out of the editor, and in the second case we want to show an error flag explaining that permissions have changed.
        // If we're on a live page and the page was deleted or archived, we don't want to show <NotFound /> nor kick the user out. Instead we expect the editor to be disabled and we'll show a flag. (This also helps resolve a race condition where <NotFound /> can be shown before the archiving user gets redirected.)
        if (!isLivePage || isLivePage && !isResourceDeletedOrArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, collabEditInitialized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
            collabEditError: collabEditError
        }), isResourceDeletedOrArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        }));
        else if (isLivePage && isResourceDeletedOrArchived) // Stop the heartbeat callback to prevent it from kicking the user out of the editor. We want the user to stay in the editor with a flag visible, until they refresh (or if they're the archiver, are redirected).
        stopHeartbeatCallback();
    }
    const checkPermissionsErrorHandler = (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === 'edit';
    if (!isTransition && checkPermissionsErrorHandler) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
        accessType: "edit",
        contentId: contentId
    });
    if ((0, $5MyXJ.isPermissionError)(heartbeatError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
        heartbeatError: heartbeatError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
        accessType: "edit",
        contentId: contentId
    }));
    if (saveDraftError) {
        // For non 403 and non 404 saveDraft errors, we still want to render editor content, but in disabled state
        if (saveDraftError.statusCode === 403 || saveDraftError.statusCode === 404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
            saveDraftError: saveDraftError
        }), saveDraftError.statusCode === 403 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        }), saveDraftError.statusCode === 404 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null));
    }
    return(// TODO: display ADFParseError if passed in as a prop (from content reconciliation)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        modal: true,
        attribution: attribution
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>// The wiki-content class name is required to avoid breaking macros that rely on DOM selectors
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Wrapper // We want to set the banner height to 0 when in Embedded Confluence because banners are inserted in the
        , {
            // BannerContainer component, which is rendered in the PageLayout component, which is not rendered in Embedded Confluence.
            bannerHeight: isEmbeddedConfluence ? 0 : bannerState.getTotalHeight(includeTopNav) + panelHeight,
            "data-testid": "editor-wrapper",
            "data-fabric-mode": isUnpublishedDraft ? 'create' : 'edit',
            "data-content-subtype": isLivePage ? 'live' : undefined,
            className: "wiki-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$WithPanels, null, (0, $9wGTI.fg)('confluence_annotate_3p_web_panel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: "atl-general-web-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first"
        })), children, !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_EDITOR_SAVEBAR)
        }))), (0, $9wGTI.fg)('confluence_annotate_3p_web_panel_footer') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: "atl-footer-web-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, {
            showPanel: false,
            "data-testid": "atl-footer-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_FOOTER)
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$Panel, {
            showPanel: false,
            "data-testid": "atl-footer-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_FOOTER)
        })), heartbeatErrorFlag.showFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
            heartbeatError: heartbeatErrorFlag.heartbeatError
        }), collabEditError && (collabEditError.status === 500 || collabEditError.code === (0, $h3X17.PROVIDER_ERROR_CODE).LOCKED) && // unhandled error, no recovery steps at this point
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
            collabEditError: collabEditError
        }), collabRecoveryError && collabRecoveryError instanceof (0, $S6mif.CollabRecoveryErrorType) && collabRecoveryError.status === 500 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
            collabRecoveryError: collabRecoveryError
        }), isLivePage && collabEditError?.status === 403 && isResourceDeletedOrArchived && // If page is archived or deleted while on a live page, show a flag
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
            collabEditError: collabEditError
        }), showRestoreSuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).RESTORE_CONTENT_SUCCESS]: true
            }),
            contentId: contentId,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }), showBlogifyConversionSuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).BLOGIFY_BLOGPOST_SUCCESS]: true,
                ...blogifyConversionSuccessFlagData
            }),
            contentId: contentId,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }), showCreateFromExtensionFlag.showFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CREATED_FROM_EXTENSION]: true,
                ...showCreateFromExtensionFlag.flagData
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9bece82eecc4ba59$export$bc6e366e749c654a), {
            contentId: contentId
        }), editorActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3e63cfb29051b1a8$export$cf6bace5e57a00db), {
            editorActions: editorActions,
            contentId: contentId
        }) : null, isAutoConverted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c186b876cfe191c$export$5960959cfc832bcd), null) : null, saveDraftError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1944a553ea5f1b71$export$23602cd239c801ed), {
            saveDraftError: saveDraftError
        })))));
};
module.exports["EditorWrapper"] = $f5a9a69398726f05$export$c0ee4c2a5005a714;

});

parcelRegister("epT4q", function(module, exports) {

let $a7ee1e55389677d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7ee1e55389677d9$var$load("dJjs8").then(()=>parcelRequire('8Ya0K'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("cvzKy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fwDOR = parcelRequire("fwDOR");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $dPJCf = parcelRequire("dPJCf");


var $9eE57 = parcelRequire("9eE57");


var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $gGHFp = parcelRequire("gGHFp");


var $5q601 = parcelRequire("5q601");


var $3D6Pp = parcelRequire("3D6Pp");


var $b8XTE = parcelRequire("b8XTE");


var $7d2Nc = parcelRequire("7d2Nc");


var $ao6k0 = parcelRequire("ao6k0");


var $9137z = parcelRequire("9137z");


var $iFjdQ = parcelRequire("iFjdQ");


var $j8hiR = parcelRequire("j8hiR");


var $hYoU4 = parcelRequire("hYoU4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7r2px = parcelRequire("7r2px");


var $juCeZ = parcelRequire("juCeZ");


var $eSLr0 = parcelRequire("eSLr0");


var $9wGTI = parcelRequire("9wGTI");


var $koYWo = parcelRequire("koYWo");


var $3VbV8 = parcelRequire("3VbV8");


var $1HVk8 = parcelRequire("1HVk8");

function $61eafb12aab3b3f9$export$4bc0e880260ffe3f() {
    return (0, $1HVk8.sniffUserBrowserExtensions)({
        extensions: [
            'grammarly'
        ]
    });
}



var $1A9t2 = parcelRequire("1A9t2");

const $049334d04d2ef297$var$extensionNodeSet = new Set([
    'extension',
    'inlineExtension',
    'bodiedExtension'
]);
const $049334d04d2ef297$export$81add81ff014aa45 = (draftBody)=>{
    if (!draftBody) return {};
    try {
        const doc = JSON.parse(draftBody);
        return (0, $1A9t2.reduce)(doc, (acc, node)=>{
            const key = $049334d04d2ef297$var$extensionNodeSet.has(node.type) ? `${node.type}:${node.attrs?.extensionKey}` : node.type;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});
    } catch (e) {
        return {};
    }
};


const $50ece43bf392701d$var$markFMPExperienceActionMeasures = (fmpTimestamp)=>{
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION), fmpTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION), fmpTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EMBEDDED_EDIT_FMP_ACTION), fmpTimestamp);
};
const $50ece43bf392701d$var$markTTIExperienceActionMeasures = (ttiTimestamp)=>{
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION), ttiTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION), ttiTimestamp);
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT, ttiTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EMBEDDED_EDIT_TTI_ACTION), ttiTimestamp);
};
const $50ece43bf392701d$var$PageLoadWrapperComponent = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, proseMirrorRenderedData: proseMirrorRenderedData, disabled: disabled, isCreate: isCreate, editSource: editSource, embeddedConfluenceSource: embeddedConfluenceSource, isLivePage: isLivePage, customPerfData: customPerfData, draftBody: draftBody })=>{
    // When editor content is rendered on server, FMP should be reported as TTR on initial load,
    // as the moment when initial HTML is rendered, not when proseMirrorRenderedData is available.
    const isTransition = (0, $dPJCf.useIsTransition)();
    const initialFmpTimestamp = !isTransition && window.__SSR_RENDERED__ ? (0, $9eE57.getMark)('CFP-63.ssr-ttr') : undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [renderPageLoadEnd, setRenderPageLoadEnd] = (0, $42omo.useState)(false);
    const [renderPageSegmentLoadEnd, setPageSegmentLoadEnd] = (0, $42omo.useState)(false);
    const [editorEnabledTimestamp, setEditorEnabledTimestamp] = (0, $42omo.useState)();
    const [fmpTimestamp, setFMPTimestamp] = (0, $42omo.useState)();
    const [isFirstLoadAfterTemplateCreation, setIsFirstLoadAfterTemplateCreation] = (0, $42omo.useState)();
    const [{ hasInitialDraft: hasInitialDraft }] = (0, $hYoU4.useNativeCollabState)();
    const { mode: contentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    const panelsModuleKeysAtlGeneral = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    });
    const panelsModuleKeysAtlFooter = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    });
    const contentExtensionMetrics = (0, $42omo.useMemo)(()=>{
        let metrics = customPerfData?.contentExtensionMetrics || {};
        if (draftBody && Object.keys(metrics).length === 0) metrics = (0, $7r2px.retrieveContentExtensionMetrics)(draftBody);
        return metrics;
    }, [
        draftBody,
        customPerfData?.contentExtensionMetrics
    ]);
    const smartlinksInitialState = !isTransition && window.__SSR_RENDERED__ && window['__SSR_SMARTLINKS__'];
    const preloadSmartlinksCount = (0, $42omo.useMemo)(()=>{
        if (!smartlinksInitialState) return 0;
        return Object.keys(smartlinksInitialState).length;
    }, [
        smartlinksInitialState
    ]);
    // When buffering is enabled, there are scenarios in which TTI can be marked prior to FMP.
    // In these cases, we wait until PM data becomes available and set TTI to be FMP.
    const markPageLoad = (fmpTimestamp, stopTime, isLivePage)=>{
        const ttiTimestamp = stopTime < fmpTimestamp ? fmpTimestamp : stopTime;
        $50ece43bf392701d$var$markTTIExperienceActionMeasures(ttiTimestamp);
        setEditorEnabledTimestamp(ttiTimestamp);
        setPageSegmentLoadEnd(true);
        if (!isLivePage) setRenderPageLoadEnd(true);
    };
    const pmRenderedTimestamp = proseMirrorRenderedData?.proseMirrorRenderedTimestamp;
    const documentStats = (0, $42omo.useMemo)(()=>(0, $049334d04d2ef297$export$81add81ff014aa45)(draftBody), [
        draftBody
    ]);
    const totalNodes = (0, $42omo.useMemo)(()=>{
        const allNodesCount = Object.values(documentStats);
        return allNodesCount.reduce((acc, nodeCnt)=>acc + nodeCnt, 0);
    }, [
        documentStats
    ]);
    // Check if this is the first load after creating a page from a template. We have experienced TTVC offenders through template-flows, so this is to identify those offenders.
    (0, $42omo.useEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_template_creation_ufo_attribute', 'isEnabled', true)) {
            const contentIdSpecificKey = `${(0, $1UApO.keys).PAGE_CREATED_FROM_TEMPLATE_PREFIX}${contentId}`;
            const templateCreatedTimestamp = (0, $17wUi.confluenceLocalStorageInstance).getItem(contentIdSpecificKey);
            if (templateCreatedTimestamp) {
                const timeSinceCreation = Date.now() - parseInt(templateCreatedTimestamp, 10);
                // Only consider it valid if it happened within the last 15 seconds. This is to avoid reading stale localStorage values.
                if (timeSinceCreation < 15000) setIsFirstLoadAfterTemplateCreation(true);
                else setIsFirstLoadAfterTemplateCreation(false);
                (0, $17wUi.confluenceLocalStorageInstance).removeItem(contentIdSpecificKey);
            } else setIsFirstLoadAfterTemplateCreation(false);
        }
    }, [
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        const renderContentTimestamp = pmRenderedTimestamp || initialFmpTimestamp;
        // mark FMP only once proseMirrorRenderedData has a defined value
        if (!fmpTimestamp && renderContentTimestamp) {
            setFMPTimestamp(renderContentTimestamp);
            $50ece43bf392701d$var$markFMPExperienceActionMeasures(renderContentTimestamp);
        }
        // Initially, when TTI is being marked for the first time, PM data either be defined or undefined
        if (typeof editorEnabledTimestamp === 'undefined' && !disabled) {
            const stopTime = performance.now();
            if (editSource === 'EmbeddedEditor') {
                const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                const uniqueKey = observableObject?.object?.uniqueKey;
                sendMetrics({
                    timestamp: Date.now(),
                    ...uniqueKey && (0, $9wGTI.fg)('platform_deprecate_lp_cc_embed') ? {
                        customData: {
                            uniqueKey: uniqueKey
                        }
                    } : {}
                }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_EDITOR_TTI)}`);
            }
            // if PM data is already available, mark the TTI and page load end
            if (fmpTimestamp && !renderPageLoadEnd) markPageLoad(fmpTimestamp, stopTime, isLivePage);
            else {
                // if PM data is not yet available, save the TTI to be used later when FMP becomes defined
                $50ece43bf392701d$var$markTTIExperienceActionMeasures(stopTime);
                setEditorEnabledTimestamp(stopTime);
            }
            (0, $koYWo.sendEditorStartedPageEvent)(createAnalyticsEvent, {
                isCreate: isCreate
            });
        } else if (editorEnabledTimestamp) // once PM data is available, mark the TTI and page load end
        {
            if (fmpTimestamp && !renderPageLoadEnd) markPageLoad(fmpTimestamp, editorEnabledTimestamp, isLivePage);
        }
    }, [
        initialFmpTimestamp,
        pmRenderedTimestamp,
        editorEnabledTimestamp,
        fmpTimestamp,
        disabled,
        renderPageLoadEnd,
        createAnalyticsEvent,
        isCreate,
        isLivePage,
        customPerfData,
        editSource,
        sendMetrics
    ]);
    // PageSegmentLoadEnd & PageLoadEnd have common custom data. PageLoadEnd is only fired for non-live pages.
    const isContentModeDense = contentMode === 'compact';
    const commonCustomData = {
        fabric: true,
        isLivePage: isLivePage,
        embeddedConfluenceSource: embeddedConfluenceSource,
        documentStats: documentStats,
        contentExtensionMetrics: contentExtensionMetrics,
        preloadSmartlinksCount: preloadSmartlinksCount,
        totalNodes: totalNodes,
        isFirstLoadAfterTemplateCreation: isFirstLoadAfterTemplateCreation
    };
    if ((0, $9wGTI.fg)('editor-ai-contentmode-performance-metric')) commonCustomData['isContentModeDense'] = isContentModeDense;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "AwaitEditorSegment",
        hold: !renderPageSegmentLoadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $3VbV8.EDITOR_METRIC)
    }), fmpTimestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3D6Pp.PageLoadMarkFMP), {
        timestamp: fmpTimestamp
    }), renderPageSegmentLoadEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        key: `end-segment-${contentId}`,
        metric: (0, $3VbV8.EDITOR_METRIC),
        stopTime: editorEnabledTimestamp,
        customData: {
            ...commonCustomData,
            ...customPerfData
        }
    }), renderPageLoadEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ao6k0.PageLoadEnd), {
        key: `end-page-${contentId}`,
        metric: editSource === 'EmbeddedEditor' ? (0, $3VbV8.EMBEDDED_EDIT_PAGE_LOAD) : (0, $3VbV8.EDIT_PAGE_LOAD),
        stopTime: editorEnabledTimestamp,
        customData: {
            ...commonCustomData,
            contentId: contentId,
            isCreate: isCreate,
            collabService: 'ncs',
            experienceActionMeasures: (0, $iFjdQ.ExperienceActionMeasures).getMeasures(),
            collabEditProviderMeasures: (0, $9137z.CollabEditProviderMeasures).getMeasures(),
            editSource: editSource,
            proseMirrorRenderedData: proseMirrorRenderedData,
            hasInitialDraft: hasInitialDraft,
            browserExtensions: (0, $61eafb12aab3b3f9$export$4bc0e880260ffe3f)(),
            webPanelsAtlGeneral: panelsModuleKeysAtlGeneral,
            webPanelsAtlFooter: panelsModuleKeysAtlFooter
        }
    }));
});
const $50ece43bf392701d$export$cff79a690992c9f3 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($50ece43bf392701d$var$PageLoadWrapperComponent);
module.exports["PageLoadWrapper"] = $50ece43bf392701d$export$cff79a690992c9f3;

});

parcelRegister("dWbBL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rj8Z = parcelRequire("8rj8Z");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $aJPUt = parcelRequire("aJPUt");


var $7d2Nc = parcelRequire("7d2Nc");


var $ep3mz = parcelRequire("ep3mz");


var $9qW65 = parcelRequire("9qW65");





var $inPa6 = parcelRequire("inPa6");

const $f0ac822d8f33c68a$export$55a4b363793a10d0 = (isContentCreationPanelShown, contentId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasScreenEventFired = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasScreenEventFired.current && isContentCreationPanelShown) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'templateDrawer',
                    objectId: contentId
                }
            }).fire();
            hasScreenEventFired.current = true;
        }
        // dont fire a close event until its been opened before
        if (hasScreenEventFired.current) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: isContentCreationPanelShown ? 'opened' : 'closed',
                actionSubject: 'templateDrawer',
                objectId: contentId,
                actionSubjectId: isContentCreationPanelShown ? 'templateDrawerOpened' : 'templateDrawerClosed'
            }
        }).fire();
    }, [
        isContentCreationPanelShown,
        createAnalyticsEvent,
        contentId
    ]);
};






var $1kHsc = parcelRequire("1kHsc");





var $gykrH = parcelRequire("gykrH");


var $1A7bE = parcelRequire("1A7bE");

const $97753ca4d20e5422$export$e27c5ac29356c803 = [
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE),
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE),
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE)
];
const $97753ca4d20e5422$export$5af17974359daea7 = (experienceTracker, subExperiences)=>(event)=>{
        const editPageExperienceEnded = event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $gykrH.isStop)(event);
        if (editPageExperienceEnded) $97753ca4d20e5422$export$fbef40dd3c73dfed(experienceTracker, subExperiences, `${(0, $irVI7.EDIT_PAGE_EXPERIENCE)} experience ended`);
    };
const $97753ca4d20e5422$export$fbef40dd3c73dfed = (experienceTracker, subExperiences, reason)=>{
    const allLoadPanelExperiences = [
        (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        ...subExperiences
    ];
    allLoadPanelExperiences.forEach((name)=>{
        experienceTracker.abort({
            name: name,
            reason: reason
        });
    });
};
const $97753ca4d20e5422$export$7bbca367109bb861 = (subExperiences)=>(events, experience)=>{
        (0, $1A7bE.collectAll)(subExperiences)(events, experience);
    };
const $97753ca4d20e5422$export$592985e5f8127ac4 = (isSpacePickerDisabled)=>{
    if (isSpacePickerDisabled) return $97753ca4d20e5422$export$e27c5ac29356c803.filter((subexperience)=>subexperience !== (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE));
    return $97753ca4d20e5422$export$e27c5ac29356c803;
};


const $3c4a4cbc3a864190$export$b6c47fafdd5a8f13 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        return experienceTracker.subscribe((0, $97753ca4d20e5422$export$5af17974359daea7)(experienceTracker, (0, $97753ca4d20e5422$export$e27c5ac29356c803)));
    }, [
        experienceTracker
    ]);
    const abortExperiences = (0, $42omo.useCallback)((reason)=>{
        (0, $97753ca4d20e5422$export$fbef40dd3c73dfed)(experienceTracker, (0, $97753ca4d20e5422$export$e27c5ac29356c803), reason);
    }, [
        experienceTracker
    ]);
    return {
        abortTemplatePanelLoadExperiences: abortExperiences
    };
};


/* ContentCreationPanelTabs.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 



var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $4A7Gn = parcelRequire("4A7Gn");

var $gCbPZ = parcelRequire("gCbPZ");

var $0DTaW = parcelRequire("0DTaW");

var $k0WY4 = parcelRequire("k0WY4");





var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");





var $gfIPU = parcelRequire("gfIPU");


var $7zgzO = parcelRequire("7zgzO");


var $c3Qwv = parcelRequire("c3Qwv");


var $jmjWc = parcelRequire("jmjWc");


const $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xum4K",
    name: "TemplatePanel",
    loader: async ()=>(await (parcelRequire("4vs03"))).TemplatePanel
});






const $063472e56b7451b3$export$b3ebd135320cfc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "T0xtm",
    name: "SourcesList",
    loader: async ()=>(await (parcelRequire("f5Xhw"))).SourcesList
});



var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $c5gk7 = parcelRequire("c5gk7");


var $lTuad = parcelRequire("lTuad");

/**
 * Looking for gridSize? Use space tokens instead. If you need a token above 80px, or if you're setting width/height, just hardcode your value e.g. 240px.
 * Looking for borderRadius? Use a hardcoded 3px until tokens are available.
 */ // TODO(brizvash): move it to separate package or check is atlaskit will become compatible with compiled
const $81d67ebdabda9710$export$ddefa1de84eb00c6 = 400; // layers.layer()
const $81d67ebdabda9710$export$e2b78fc999d64ab4 = 300; // layers.dialog()
const $81d67ebdabda9710$export$ae37325b3735a1de = 200; // layers.navigation()



var $frIzR = parcelRequire("frIzR");












var $eyWa4 = parcelRequire("eyWa4");


var $cO1el = parcelRequire("cO1el");


var $2sWSU = parcelRequire("2sWSU");


var $6sN9o = parcelRequire("6sN9o");


var $bQm3c = parcelRequire("bQm3c");


var $kBRLU = parcelRequire("kBRLU");


var $dZUkS = parcelRequire("dZUkS");


var $fnUlK = parcelRequire("fnUlK");






















var $esRft = parcelRequire("esRft");


var $1Whri = parcelRequire("1Whri");





var $4Nwes = parcelRequire("4Nwes");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");



var $iXCQx = parcelRequire("iXCQx");


var $2W0qg = parcelRequire("2W0qg");








var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $4oS56 = parcelRequire("4oS56");





var $5ZqQS = parcelRequire("5ZqQS");

const $588dd80fd3e94085$export$7b169887c898052a = ()=>{
    const $ = (0, $frIzR.c)(2);
    const { editorAPI: editorAPI } = (0, $42omo.useContext)((0, $4oS56.EditorContextPanelContext));
    let t0;
    if ($[0] !== editorAPI) {
        t0 = (snippet)=>{
            if (!editorAPI?.core?.actions?.execute) return false;
            const body = snippet.body;
            if (!body) return false;
            try {
                editorAPI.core.actions.execute((t2)=>{
                    const { tr: tr } = t2;
                    const schema = tr.doc.type.schema;
                    const content = Array.isArray(body) ? (0, $5SAOw.Fragment).fromJSON(schema, body) : schema.nodeFromJSON(body);
                    (0, $8m4tT.safeInsert)(content, undefined, true)(tr);
                    return tr;
                });
                return true;
            } catch (t1) {
                const error = t1;
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
                });
                return false;
            }
        };
        $[0] = editorAPI;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};



var $e9jnk = parcelRequire("e9jnk");











var $hEeUR = parcelRequire("hEeUR");











var $4MPLO = parcelRequire("4MPLO");


var $ibzAc = parcelRequire("ibzAc");


var $4FxUL = parcelRequire("4FxUL");


var $32x2E = parcelRequire("32x2E");

const $fa6fa2919b518a64$export$29d807bc39faaa49 = (cloudId, userId)=>{
    const dataProviders = (0, $4FxUL.default).create({});
    dataProviders.setProvider('emojiProvider', (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    }));
    return dataProviders;
};


const $e12252c7883ca5e3$var$styles = {
    scaledContainer: "_1reo15vq _18m915vq _uiztglyw _lcxvglyw",
    scaledContent: "_1rjcu2gc _18zrutpp _4t3i1wug _8hrz5d63"
}; /** Desired output dimensions (container size) */ 
const $e12252c7883ca5e3$export$a13d19bdacf806db = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { snippet: snippet, dimensions: dimensions, renderWidth: renderWidth } = t0;
    let t1;
    if ($[0] !== snippet.body) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12252c7883ca5e3$var$Renderer, {
            adf: snippet.body
        });
        $[0] = snippet.body;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== dimensions || $[3] !== renderWidth || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12252c7883ca5e3$var$ScaledContainer, {
            dimensions: dimensions,
            renderWidth: renderWidth
        }, t1);
        $[2] = dimensions;
        $[3] = renderWidth;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $e12252c7883ca5e3$var$Renderer = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { adf: adf } = t0;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const handleRenderError = $e12252c7883ca5e3$var$_temp;
    let t1;
    if ($[0] !== cloudId || $[1] !== userId) {
        t1 = (0, $fa6fa2919b518a64$export$29d807bc39faaa49)(cloudId, userId);
        $[0] = cloudId;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const dataProviders = t1;
    let t2;
    if ($[3] !== adf) {
        t2 = (0, $4MPLO.wrapAdfWithDocNode)(adf);
        $[3] = adf;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== dataProviders || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
            document: t2,
            appearance: "full-page",
            allowPlaceholderText: true,
            dataProviders: dataProviders,
            onError: handleRenderError
        });
        $[5] = dataProviders;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $e12252c7883ca5e3$var$ScaledContainer = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children, dimensions: dimensions, renderWidth: renderWidth } = t0;
    let t1;
    if ($[0] !== dimensions.maxHeight || $[1] !== dimensions.width) {
        t1 = {
            width: dimensions.width,
            maxHeight: dimensions.maxHeight
        };
        $[0] = dimensions.maxHeight;
        $[1] = dimensions.width;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = `scale(calc((${dimensions.width}) / ${renderWidth}px))`;
    let t3;
    if ($[3] !== renderWidth || $[4] !== t2) {
        t3 = {
            transform: t2,
            width: renderWidth
        };
        $[3] = renderWidth;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== children || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e12252c7883ca5e3$var$styles.scaledContent,
            style: t3
        }, children);
        $[6] = children;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: $e12252c7883ca5e3$var$_temp2,
            xcss: $e12252c7883ca5e3$var$styles.scaledContainer,
            style: t1
        }, t4);
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $e12252c7883ca5e3$var$_temp(error) {
    const reasonString = error instanceof Error ? error.message : JSON.stringify(error);
    const errorToLog = new Error(`Error when rendering snippet preview: ${reasonString}`);
    (0, $5ZqQS.getMonitoringClient)().submitError(errorToLog, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
}
function $e12252c7883ca5e3$var$_temp2(node) {
    return node?.setAttribute("inert", "");
}
















var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $9VJDA = parcelRequire("9VJDA");


var $1Zr9M = parcelRequire("1Zr9M");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");








var $3gadb = parcelRequire("3gadb");











var $8aF6s = parcelRequire("8aF6s");


var $d8dIT = parcelRequire("d8dIT");










var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");







var $lsxnT = parcelRequire("lsxnT");


var $7aRa9 = parcelRequire("7aRa9");





var $64ncc = parcelRequire("64ncc");

const $629f1f7885b694b1$var$DeleteSnippetModalWithFlags = ({ snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, flags: flags, editorAPI: editorAPI })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const titleId = (0, $42omo.useId)();
    const intl = (0, $8C5kA.default)();
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const [isDeleting, setIsDeleting] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const handleConfirm = async ()=>{
        setIsDeleting(true);
        setError(null);
        try {
            await snippetsActions.deleteSnippet(snippet.snippetId, {
                flags: flags,
                intl: intl,
                editorAPI: editorAPI ?? null
            });
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: onClose,
        onCloseComplete: onCloseComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        id: titleId,
        weight: "semibold",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $64ncc.messages).deleteTemplateModalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $64ncc.messages).deleteTemplateModalBody)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.danger",
        size: "small"
    }, error.message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClose,
        isDisabled: isDeleting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $64ncc.messages).deleteTemplateModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "danger",
        onClick: handleConfirm,
        isLoading: isDeleting,
        isDisabled: isDeleting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $64ncc.messages).deleteTemplateModalConfirmButton)))));
};
const $629f1f7885b694b1$export$424b6d728b5615c6 = (0, $7aRa9.withFlags)($629f1f7885b694b1$var$DeleteSnippetModalWithFlags);





const $f3d6cebd6ac43154$export$fffb2c8c8b22d965 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const { onDuplicate: onDuplicate } = options;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { editorAPI: editorAPI } = (0, $42omo.useContext)((0, $4oS56.EditorContextPanelContext));
    let t2;
    if ($[2] !== editorAPI || $[3] !== showModal) {
        t2 = (snippet)=>{
            showModal((0, $d8dIT.SnippetEditorModal), {
                mode: (0, $e9jnk.SnippetEditorModalMode).EDIT,
                snippet: snippet,
                editorAPI: editorAPI
            });
        };
        $[2] = editorAPI;
        $[3] = showModal;
        $[4] = t2;
    } else t2 = $[4];
    const handleEdit = t2;
    let t3;
    if ($[5] !== onDuplicate) {
        t3 = (snippet_0)=>{
            onDuplicate?.(snippet_0);
        };
        $[5] = onDuplicate;
        $[6] = t3;
    } else t3 = $[6];
    const handleDuplicate = t3;
    let t4;
    if ($[7] !== editorAPI || $[8] !== showModal) {
        t4 = (snippet_1)=>{
            showModal((0, $629f1f7885b694b1$export$424b6d728b5615c6), {
                snippet: snippet_1,
                editorAPI: editorAPI
            });
        };
        $[7] = editorAPI;
        $[8] = showModal;
        $[9] = t4;
    } else t4 = $[9];
    const handleDelete = t4;
    let t5;
    if ($[10] !== handleDelete || $[11] !== handleDuplicate || $[12] !== handleEdit) {
        t5 = {
            handleEdit: handleEdit,
            handleDuplicate: handleDuplicate,
            handleDelete: handleDelete
        };
        $[10] = handleDelete;
        $[11] = handleDuplicate;
        $[12] = handleEdit;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};





const $629c4fdd0f68cfc2$var$styles = {
    actionsContainer: "_v564wz4i _1o9zidpf _tzy4idpf _1mygkb7n",
    actionsContainerVisible: "_tzy4kb7n"
};
const $629c4fdd0f68cfc2$var$messages = (0, $cgtv4.defineMessages)({
    moreActions: {
        id: "snippets.panel.item.more.actions",
        defaultMessage: "Block Templates actions"
    },
    edit: {
        id: "snippets.panel.item.edit",
        defaultMessage: "Edit"
    },
    duplicate: {
        id: "snippets.panel.item.duplicate",
        defaultMessage: "Duplicate"
    },
    delete: {
        id: "snippets.panel.item.delete",
        defaultMessage: "Delete"
    }
});
const $629c4fdd0f68cfc2$export$e04c6cb8bbe57829 = (t0)=>{
    const $ = (0, $frIzR.c)(51);
    const { snippet: snippet, isHovered: isHovered, onMenuOpenChange: onMenuOpenChange } = t0;
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    const { handleEdit: handleEdit, handleDuplicate: handleDuplicate, handleDelete: handleDelete } = (0, $f3d6cebd6ac43154$export$fffb2c8c8b22d965)();
    let t1;
    if ($[0] !== snippet.createdBy.accountId) {
        t1 = snippet.createdBy.accountId.toLowerCase();
        $[0] = snippet.createdBy.accountId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $e9jnk.ATLASSIAN_ACCOUNT_ID).toLowerCase();
        $[2] = t2;
    } else t2 = $[2];
    const showEditAndDelete = t1 !== t2;
    let t3;
    if ($[3] !== onMenuOpenChange) {
        t3 = (t4)=>{
            const { isOpen: isOpen } = t4;
            setIsMenuOpen(isOpen);
            onMenuOpenChange?.(isOpen);
        };
        $[3] = onMenuOpenChange;
        $[4] = t3;
    } else t3 = $[4];
    const handleMenuOpenChange = t3;
    const t4 = `snippet-panel-actions-${snippet.snippetId}`;
    const t5 = (isHovered || isMenuOpen) && $629c4fdd0f68cfc2$var$styles.actionsContainerVisible;
    let t6;
    if ($[5] !== t5) {
        t6 = (0, $1Whri.cx)($629c4fdd0f68cfc2$var$styles.actionsContainer, t5);
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== intl || $[8] !== isMenuOpen) {
        t7 = isMenuOpen ? "" : intl.formatMessage($629c4fdd0f68cfc2$var$messages.moreActions);
        $[7] = intl;
        $[8] = isMenuOpen;
        $[9] = t7;
    } else t7 = $[9];
    const t8 = `snippet-ellipsis-menu-${snippet.snippetId}`;
    let t9;
    if ($[10] !== intl || $[11] !== isMenuOpen) {
        t9 = (t10)=>{
            const { triggerRef: triggerRef, ...props } = t10;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                label: intl.formatMessage($629c4fdd0f68cfc2$var$messages.moreActions),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                "aria-expanded": isMenuOpen ? "true" : "false"
            });
        };
        $[10] = intl;
        $[11] = isMenuOpen;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== handleEdit || $[14] !== intl || $[15] !== showEditAndDelete || $[16] !== snippet) {
        t10 = showEditAndDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: ()=>handleEdit(snippet),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                label: intl.formatMessage($629c4fdd0f68cfc2$var$messages.edit)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $629c4fdd0f68cfc2$var$messages.edit));
        $[13] = handleEdit;
        $[14] = intl;
        $[15] = showEditAndDelete;
        $[16] = snippet;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== handleDuplicate || $[19] !== snippet) {
        t11 = ()=>handleDuplicate(snippet);
        $[18] = handleDuplicate;
        $[19] = snippet;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== intl) {
        t12 = intl.formatMessage($629c4fdd0f68cfc2$var$messages.duplicate);
        $[21] = intl;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: t12
        });
        $[23] = t12;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $629c4fdd0f68cfc2$var$messages.duplicate);
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== t11 || $[27] !== t13) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: t11,
            elemBefore: t13
        }, t14);
        $[26] = t11;
        $[27] = t13;
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== handleDelete || $[30] !== intl || $[31] !== showEditAndDelete || $[32] !== snippet) {
        t16 = showEditAndDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: ()=>handleDelete(snippet),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                label: intl.formatMessage($629c4fdd0f68cfc2$var$messages.delete)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $629c4fdd0f68cfc2$var$messages.delete));
        $[29] = handleDelete;
        $[30] = intl;
        $[31] = showEditAndDelete;
        $[32] = snippet;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== t10 || $[35] !== t15 || $[36] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t10, t15, t16);
        $[34] = t10;
        $[35] = t15;
        $[36] = t16;
        $[37] = t17;
    } else t17 = $[37];
    let t18;
    if ($[38] !== handleMenuOpenChange || $[39] !== isMenuOpen || $[40] !== t17 || $[41] !== t8 || $[42] !== t9) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            placement: "bottom-end",
            testId: t8,
            trigger: t9,
            appearance: "tall",
            isOpen: isMenuOpen,
            onOpenChange: handleMenuOpenChange
        }, t17);
        $[38] = handleMenuOpenChange;
        $[39] = isMenuOpen;
        $[40] = t17;
        $[41] = t8;
        $[42] = t9;
        $[43] = t18;
    } else t18 = $[43];
    let t19;
    if ($[44] !== t18 || $[45] !== t7) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t7,
            position: "bottom",
            hideTooltipOnClick: true
        }, t18);
        $[44] = t18;
        $[45] = t7;
        $[46] = t19;
    } else t19 = $[46];
    let t20;
    if ($[47] !== t19 || $[48] !== t4 || $[49] !== t6) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: t4,
            xcss: t6
        }, t19);
        $[47] = t19;
        $[48] = t4;
        $[49] = t6;
        $[50] = t20;
    } else t20 = $[50];
    return t20;
};


const $07d8ab982c900cff$var$SNIPPET_PREVIEW_WIDTH = 140;
const $07d8ab982c900cff$var$SNIPPET_PREVIEW_HEIGHT = 80;
const $07d8ab982c900cff$var$EDITOR_PRE_SCALE_WIDTH = 800;
const $07d8ab982c900cff$var$PREVIEW_PADDING_BLOCK = "var(--ds-space-075, 6px)";
const $07d8ab982c900cff$var$PREVIEW_PADDING_INLINE = "var(--ds-space-100, 8px)";
const $07d8ab982c900cff$var$styles = {
    cardWrapper: "_2rko12b0 _kqswh2mm _1bsb1osq _4t3i53f4 _bfhk1j28 _irr319i6",
    cardWrapperActive: "_bfhk19i6",
    cardButton: "_y3gn1e5h _19bvu2gc _u5f3u2gc _1bsb1osq _4t3i1osq _bfhk1j28",
    actionsWrapper: "_kqswstnw _154iu2gc _1xi2u2gc _1pbykb7n",
    preview: "_2rko1mok _19itia51 _1reo15vq _18m915vq _1bsb11ux _1ul911ux _4t3iys9h _bfhk1j28",
    titleContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _y3gn1e5h _u5f31jfw"
};
const $07d8ab982c900cff$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    snippetUses: {
        id: "snippets.panel.item.uses",
        defaultMessage: "Uses"
    },
    snippetCardAriaLabel: {
        id: "snippets.panel.item.card.aria-label",
        defaultMessage: "Block Template: {name}"
    },
    snippetPreview: {
        id: "snippets.panel.item.preview",
        defaultMessage: "Preview"
    }
});
const $07d8ab982c900cff$export$3a5e77e0ee8e9941 = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { snippet: snippet } = t0;
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const insertSnippet = (0, $588dd80fd3e94085$export$7b169887c898052a)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsHovered(true);
        $[0] = t1;
    } else t1 = $[0];
    const handleMouseEnter = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsHovered(false);
        $[1] = t2;
    } else t2 = $[1];
    const handleMouseLeave = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (isOpen)=>setIsMenuOpen(isOpen);
        $[2] = t3;
    } else t3 = $[2];
    const handleMenuOpenChange = t3;
    let t4;
    if ($[3] !== insertSnippet || $[4] !== snippet) {
        t4 = ()=>insertSnippet(snippet);
        $[3] = insertSnippet;
        $[4] = snippet;
        $[5] = t4;
    } else t4 = $[5];
    const onClick = t4;
    const t5 = isMenuOpen && $07d8ab982c900cff$var$styles.cardWrapperActive;
    let t6;
    if ($[6] !== t5) {
        t6 = (0, $1Whri.cx)($07d8ab982c900cff$var$styles.cardWrapper, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== snippet) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignInline: "start",
            alignBlock: "center",
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07d8ab982c900cff$var$SnippetPreviewContainer, {
            snippet: snippet
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07d8ab982c900cff$var$SnippetInfo, {
            snippet: snippet
        }));
        $[8] = snippet;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== onClick || $[11] !== snippet || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07d8ab982c900cff$var$SnippetCardButton, {
            snippet: snippet,
            onClick: onClick
        }, t7);
        $[10] = onClick;
        $[11] = snippet;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== isHovered || $[15] !== snippet) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $07d8ab982c900cff$var$styles.actionsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $629c4fdd0f68cfc2$export$e04c6cb8bbe57829), {
            snippet: snippet,
            isHovered: isHovered,
            onMenuOpenChange: handleMenuOpenChange
        }));
        $[14] = isHovered;
        $[15] = snippet;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t6 || $[18] !== t8 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t6,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        }, t8, t9);
        $[17] = t6;
        $[18] = t8;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
};
const $07d8ab982c900cff$var$SnippetCardButton = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, snippet: snippet, onClick: onClick } = t0;
    const intl = (0, $8C5kA.default)();
    const t1 = `snippet-card-button-${snippet.snippetId}`;
    let t2;
    if ($[0] !== intl || $[1] !== snippet.name) {
        t2 = intl.formatMessage($07d8ab982c900cff$export$defe85febe8b728c.snippetCardAriaLabel, {
            name: snippet.name
        });
        $[0] = intl;
        $[1] = snippet.name;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== onClick || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $07d8ab982c900cff$var$styles.cardButton,
            onClick: onClick,
            testId: t1,
            "aria-label": t2
        }, children);
        $[3] = children;
        $[4] = onClick;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $07d8ab982c900cff$var$SnippetPreviewContainer = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { snippet: snippet } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            paddingBlock: $07d8ab982c900cff$var$PREVIEW_PADDING_BLOCK,
            paddingInline: $07d8ab982c900cff$var$PREVIEW_PADDING_INLINE
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            width: `calc(${$07d8ab982c900cff$var$SNIPPET_PREVIEW_WIDTH}px - (${$07d8ab982c900cff$var$PREVIEW_PADDING_INLINE} * 2))`,
            maxHeight: `calc(${$07d8ab982c900cff$var$SNIPPET_PREVIEW_HEIGHT}px - (${$07d8ab982c900cff$var$PREVIEW_PADDING_BLOCK} * 2))`
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== snippet) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $07d8ab982c900cff$var$styles.preview,
            style: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e12252c7883ca5e3$export$a13d19bdacf806db), {
            snippet: snippet,
            dimensions: t2,
            renderWidth: $07d8ab982c900cff$var$EDITOR_PRE_SCALE_WIDTH
        }));
        $[2] = snippet;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
const $07d8ab982c900cff$var$CreatedByAvatar = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { snippetOwner: snippetOwner } = t0;
    const shouldUseAtlassianIcon = snippetOwner.accountId.toLowerCase() === (0, $e9jnk.ATLASSIAN_ACCOUNT_ID);
    if (shouldUseAtlassianIcon) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
                appearance: "brand",
                size: "xsmall"
            });
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    const t1 = snippetOwner;
    let t2;
    if ($[1] !== snippetOwner.displayName || $[2] !== t1.avatarUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            appearance: "circle",
            size: "xsmall",
            src: t1.avatarUrl,
            name: snippetOwner.displayName
        });
        $[1] = snippetOwner.displayName;
        $[2] = t1.avatarUrl;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
});
const $07d8ab982c900cff$var$SnippetInfo = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { snippet: snippet } = t0;
    let t1;
    if ($[0] !== snippet.name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $07d8ab982c900cff$var$styles.titleContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            maxLines: 3,
            weight: "bold"
        }, snippet.name)));
        $[0] = snippet.name;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== snippet.createdBy) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07d8ab982c900cff$var$CreatedByAvatar, {
            snippetOwner: snippet.createdBy
        });
        $[2] = snippet.createdBy;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== snippet.createdBy.displayName) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 1
        }, snippet.createdBy.displayName);
        $[4] = snippet.createdBy.displayName;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            separator: "\u2022"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignInline: "center",
            alignBlock: "center",
            space: "space.050"
        }, t2, t3));
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            alignInline: "start",
            alignBlock: "start",
            space: "space.075",
            grow: "fill"
        }, t1, t4);
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};


const $35ff15f955ef7b49$export$53c9a51d6103acb5 = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { snippets: snippets } = t0;
    let t1;
    if ($[0] !== snippets) {
        t1 = snippets?.map($35ff15f955ef7b49$var$_temp);
        $[0] = snippets;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $35ff15f955ef7b49$var$_temp(snippet) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $07d8ab982c900cff$export$3a5e77e0ee8e9941), {
        key: snippet.snippetId,
        snippet: snippet
    });
}




















const $32792490397e160a$var$styles = {
    searchBarContainer: "_2rko1qi0 _4t3i1ylp _1bsb1osq _bfhkizff _otyru2gc"
};
const $32792490397e160a$export$9aa973586059796c = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $32792490397e160a$var$styles.searchBarContainer
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};













const $c68bbe301cfc15ae$var$styles = {
    categoryItem: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rko1qi0 _4t3izwfg _1ul9ys9h _bfhkizff"
};
const $c68bbe301cfc15ae$export$af28f945e0fd1a8 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c68bbe301cfc15ae$var$styles.categoryItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c68bbe301cfc15ae$var$styles.categoryItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c68bbe301cfc15ae$var$styles.categoryItem
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};















const $ee289c3c737d72ec$var$styles = {
    card: "_19bv1b66 _u5f3idpf _ca0qu2gc _n3tdu2gc _1bsb1osq _4t3i53f4 _bfhk1j28",
    skeletonPreview: "_2rko1mok _4t3iymf6 _1bsb68cl _bfhkizff",
    placeholderTitle: "_2rko12b0 _4t3i7vkz _1bsb1osq _bfhkizff",
    placeholderSubtitle: "_2rko12b0 _4t3i7vkz _1bsb1nrf _bfhkizff",
    skeletonAvatar: "_2rko12b0 _4t3i7vkz _1bsb7vkz _1ul97vkz _bfhkizff",
    fullWidth: "_1bsb1osq"
};
const $ee289c3c737d72ec$export$8fdbf8ba72a7b625 = ()=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ee289c3c737d72ec$var$styles.skeletonPreview
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ee289c3c737d72ec$var$styles.placeholderTitle
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ee289c3c737d72ec$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $ee289c3c737d72ec$var$styles.fullWidth,
            alignInline: "start",
            alignBlock: "center",
            space: "space.150"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $ee289c3c737d72ec$var$styles.fullWidth,
            alignInline: "start",
            alignBlock: "center",
            space: "space.075"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $ee289c3c737d72ec$var$styles.fullWidth,
            alignInline: "start",
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ee289c3c737d72ec$var$styles.skeletonAvatar
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ee289c3c737d72ec$var$styles.placeholderSubtitle
        })))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};


const $2e9cdc1c3e4e67e5$export$f8c40a5ae5bad2bc = ()=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32792490397e160a$export$9aa973586059796c), null);
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c68bbe301cfc15ae$export$af28f945e0fd1a8), null);
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            grow: "fill"
        }, t0, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee289c3c737d72ec$export$8fdbf8ba72a7b625), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee289c3c737d72ec$export$8fdbf8ba72a7b625), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee289c3c737d72ec$export$8fdbf8ba72a7b625), null)));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};


const $a6866ef267e2cffc$var$messages = (0, $cgtv4.defineMessages)({
    snippetsRecommended: {
        id: "snippets.panel.recommended",
        defaultMessage: "Recommended"
    },
    searchSnippetsPlaceholderText: {
        id: "snippets.panel.search.placeholderText",
        defaultMessage: "Search author, category, topic"
    }
});
const $a6866ef267e2cffc$export$bd9af633abea831d = ()=>{
    const $ = (0, $frIzR.c)(26);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const intl = (0, $8C5kA.default)();
    const [t0] = (0, $dZUkS.useSnippets)();
    const { isLoading: isLoading, snippets: snippets } = t0;
    const { selectedCategoryId: selectedCategoryId, searchQuery: searchQuery, filteredSnippets: filteredSnippets, setSearchQuery: setSearchQuery, setCategoryFilter: setCategoryFilter } = (0, $fnUlK.useSnippetFilters)(snippets, userId);
    const categories = (0, $kBRLU.useSnippetFilterCategories)();
    const shouldShowRecommended = selectedCategoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).ALL && searchQuery === "";
    if (isLoading) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2e9cdc1c3e4e67e5$export$f8c40a5ae5bad2bc), null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    let t1;
    if ($[1] !== intl) {
        t1 = intl.formatMessage($a6866ef267e2cffc$var$messages.searchSnippetsPlaceholderText);
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== setSearchQuery) {
        t2 = (query)=>setSearchQuery(query);
        $[3] = setSearchQuery;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = searchQuery || "";
    let t4;
    if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6sN9o.DebouncedSearchBar), {
            placeholder: t1,
            isCompact: true,
            onChange: t2,
            initialValue: t3
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== selectedCategoryId) {
        t5 = [
            selectedCategoryId
        ];
        $[9] = selectedCategoryId;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== setCategoryFilter) {
        t6 = (category)=>setCategoryFilter(category.id);
        $[11] = setCategoryFilter;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== categories || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2sWSU.CategorySelector), {
            categories: categories,
            selectedCategoryIds: t5,
            onCategorySelected: t6
        });
        $[13] = categories;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== shouldShowRecommended) {
        t8 = shouldShowRecommended && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a6866ef267e2cffc$var$messages.snippetsRecommended));
        $[17] = shouldShowRecommended;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== filteredSnippets) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35ff15f955ef7b49$export$53c9a51d6103acb5), {
            snippets: filteredSnippets
        });
        $[19] = filteredSnippets;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t4 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            grow: "fill"
        }, t4, t7, t8, t9);
        $[21] = t4;
        $[22] = t7;
        $[23] = t8;
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    return t10;
};






var $dPJCf = parcelRequire("dPJCf");


var $lJDEI = parcelRequire("lJDEI");

const $a9fe7ee9063c2de8$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    templatesTabLabel: {
        id: "editor-context-panel-content-creation-panel.template-panel.tabs.templates.label",
        defaultMessage: "Templates"
    },
    importDocTabLabel: {
        id: "editor-context-panel-content-creation-panel.template-panel.tabs.import-doc.label",
        defaultMessage: "Import"
    },
    closeLabel: {
        id: "editor-context-panel-content-creation-panel.close-label",
        defaultMessage: "Close templates and import"
    },
    blockLabel: {
        id: "editor-context-panel-content-creation-panel.block-label",
        defaultMessage: "Block"
    },
    pageLabel: {
        id: "editor-context-panel-content-creation-panel.page-label",
        defaultMessage: "Page"
    }
});
// Tab indices - the actual tab at each index varies by mode:
// - cc_snippets_dogfooding OFF (legacy): [Templates, Import]
// - cc_snippets_dogfooding ON + templates mode: [Page, Block]
// - cc_snippets_dogfooding ON + import mode: [Import] (only one tab)
const $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX = 0;
const $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX = 1;
const $a9fe7ee9063c2de8$var$ContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhkvuon _kqswh2mm _1tke1osq",
            __cmplp.disabled ? "_80om15jw" : "_80om73ad",
            __cmplp.className
        ])
    });
}); // header > body allows the sticky tabs to be on top of the tab body content as it scrolls
const $a9fe7ee9063c2de8$var$StickyTabsHeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q716j1 _kqsw1if8 _154imgjw _n3tdpxbi _1pbyowjs",
            __cmplp.className
        ])
    });
});
const $a9fe7ee9063c2de8$var$closeIconWrapperStyles = (0, $ecnYn.xcss)({
    height: '0px',
    position: 'absolute',
    right: '0',
    zIndex: 'dialog'
});
const $a9fe7ee9063c2de8$var$CustomTabPanel = ({ children: children })=>{
    const tabPanelAttributes = (0, $k0WY4.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...tabPanelAttributes,
        style: {
            padding: `0 ${"var(--ds-space-050, 4px)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: (0, $81d67ebdabda9710$export$ae37325b3735a1de)
        },
        tabIndex: -1
    }, children);
};
const $a9fe7ee9063c2de8$var$getParentPageId = (data)=>{
    const contentAncestors = data?.content?.nodes?.[0]?.ancestors ?? [];
    return contentAncestors.slice(-1)[0]?.id || '';
}; // When cc_snippets_dogfooding is ON:
//   - 'import' target tab → opens import-only mode (single Import content)
//   - 'templates', 'block', or none target tab → opens templates mode (Page | Block tabs)
// When cc_snippets_dogfooding is OFF:
//   - Always templates mode (Templates | Import tabs)
const $a9fe7ee9063c2de8$var$getPanelMode = (tabTarget, isImportDisabled)=>{
    if ((0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false)) {
        if (tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT) && !isImportDisabled) return 0, $lJDEI.PANEL_MODE_IMPORT;
        return 0, $lJDEI.PANEL_MODE_TEMPLATES;
    }
    return 0, $lJDEI.PANEL_MODE_TEMPLATES;
}; // Gets the initial tab index based on mode and query params.
// When cc_snippets_dogfooding is ON in templates mode: page=0, block=1
// When cc_snippets_dogfooding is ON in import mode: import=0 (only one tab)
// When cc_snippets_dogfooding is OFF: templates=0, import=1
const $a9fe7ee9063c2de8$var$getInitialTabTarget = (queryParams, panelMode, isImportDisabled)=>{
    const tabTarget = (0, $c3Qwv.getSingleParam)(queryParams, (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET));
    if ((0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false)) {
        if (panelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES) && tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK)) return $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX;
        return $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX; // Default to first tab
    } // Legacy behavior: templates=0, import=1
    if (tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT) && !isImportDisabled) return $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX;
    return $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX;
};
const $a9fe7ee9063c2de8$export$ea9a941ad7141159 = ({ currentSpaceKey: currentSpaceKey, contentId: contentId, title: title, onContentUpdated: onContentUpdated, isPanelDisabled: isPanelDisabled, beforeTemplateSelect: beforeTemplateSelect, hasUserAddedContent: hasUserAddedContent, beforeUpdateRequest: beforeUpdateRequest, onError: onError, closeConfigPanel: closeConfigPanel, abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext)); // Derive panelMode from query params so that switching modes updates the tabs
    const queryParams = getQueryParams();
    const tabTarget = (0, $c3Qwv.getSingleParam)(queryParams, (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET));
    const panelMode = (0, $42omo.useMemo)(()=>$a9fe7ee9063c2de8$var$getPanelMode(tabTarget, isImportDisabled), [
        tabTarget,
        isImportDisabled
    ]);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const [selectedTab, setSelectedTab] = (0, $42omo.useState)(()=>$a9fe7ee9063c2de8$var$getInitialTabTarget(getQueryParams(), panelMode, isImportDisabled)); // Update selected tab when panelMode or tabTarget changes
    const prevStateRef = (0, $42omo.useRef)({
        panelMode: panelMode,
        tabTarget: tabTarget
    });
    (0, $42omo.useEffect)(()=>{
        // When flag is OFF, the clearing useEffect sets tabTarget to null, which would
        // incorrectly reset the tab. Skip this to preserve the initial tab selection to avoid race condition.
        if (!(0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false)) return;
        const prevState = prevStateRef.current;
        const hasPanelModeChanged = prevState.panelMode !== panelMode;
        const hasTabTargetChanged = prevState.tabTarget !== tabTarget; // Update tab when mode changes, or when tab target changes in templates mode
        if (hasPanelModeChanged || hasTabTargetChanged && panelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES)) {
            const newTab = $a9fe7ee9063c2de8$var$getInitialTabTarget(getQueryParams(), panelMode, isImportDisabled);
            setSelectedTab(newTab);
        }
        prevStateRef.current = {
            panelMode: panelMode,
            tabTarget: tabTarget
        };
    }, [
        panelMode,
        tabTarget,
        getQueryParams,
        isImportDisabled
    ]);
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query ContentCreationPanelTabsTemplatePanelContentQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id ancestors{id title}}}}`, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
    const parentPageId = $a9fe7ee9063c2de8$var$getParentPageId(data);
    const handleTabSelect = (0, $42omo.useCallback)((selectedIndex)=>{
        let actionSubjectId;
        if ((0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false)) {
            if (panelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES)) {
                // Templates mode: Page (0), Block (1)
                actionSubjectId = selectedIndex === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX ? 'blockTab' : 'pageTab';
                const tabTargetQueryParam = selectedIndex === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX ? (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK) : (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES);
                setQueryParams({
                    [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: tabTargetQueryParam
                }, true);
            } else // Import mode: Import (0) - only one tab
            actionSubjectId = 'importTab';
        } else // Legacy: Templates (0), Import (1)
        actionSubjectId = selectedIndex === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX ? 'importTab' : 'templatesTab';
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorRightRail',
                action: 'clicked',
                actionSubject: 'tab',
                actionSubjectId: actionSubjectId
            }
        }).fire();
        setSelectedTab(selectedIndex);
    }, [
        setSelectedTab,
        createAnalyticsEvent,
        panelMode,
        setQueryParams
    ]);
    (0, $42omo.useEffect)(()=>{
        if (selectedTab !== $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX) abortTemplatePanelLoadExperiences('templates tab is not selected');
    }, [
        selectedTab,
        abortTemplatePanelLoadExperiences
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false)) setQueryParams({
            [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: null
        }, true);
    }, [
        setQueryParams
    ]);
    if (loading) return null; // if this tabs array gets more complex, we will need to refactor the TEMPLATES_TAB_INDEX and CONTEXT_PANEL_TAB_TARGET concept into something that isnt hardcoded here
    const tabs = (()=>{
        if ((0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false)) {
            // When cc_snippets_dogfooding is ON, we have two distinct modes:
            // 1. Templates mode: Page | Block tabs
            // 2. Import mode: Import only (single content)
            if (panelMode === (0, $lJDEI.PANEL_MODE_IMPORT)) return [
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.importDocTabLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $063472e56b7451b3$export$b3ebd135320cfc), {
                        hasUserAddedContent: hasUserAddedContent,
                        contentId: contentId,
                        parentPageId: parentPageId,
                        currentSpace: currentSpaceKey
                    })
                }
            ];
             // Templates mode: Page | Block
            return [
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.pageLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f), {
                        parentPageId: parentPageId,
                        currentSpaceKey: currentSpaceKey,
                        contentId: contentId,
                        title: title,
                        onContentUpdated: onContentUpdated,
                        isPanelDisabled: isPanelDisabled,
                        beforeTemplateSelect: beforeTemplateSelect,
                        hasUserAddedContent: hasUserAddedContent,
                        beforeUpdateRequest: beforeUpdateRequest,
                        onError: onError,
                        templateAllowList: templateAllowList,
                        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
                        isSpacePickerDisabled: isSpacePickerDisabled
                    })
                },
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.blockLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6866ef267e2cffc$export$bd9af633abea831d), null)
                }
            ];
        } // When cc_snippets_dogfooding is OFF: Templates | Import (legacy behavior)
        return [
            {
                label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.templatesTabLabel,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f), {
                    parentPageId: parentPageId,
                    currentSpaceKey: currentSpaceKey,
                    contentId: contentId,
                    title: title,
                    onContentUpdated: onContentUpdated,
                    isPanelDisabled: isPanelDisabled,
                    beforeTemplateSelect: beforeTemplateSelect,
                    hasUserAddedContent: hasUserAddedContent,
                    beforeUpdateRequest: beforeUpdateRequest,
                    onError: onError,
                    templateAllowList: templateAllowList,
                    isAlwaysDiscardChanges: isAlwaysDiscardChanges,
                    isSpacePickerDisabled: isSpacePickerDisabled
                })
            },
            ...!isImportDisabled ? [
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.importDocTabLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $063472e56b7451b3$export$b3ebd135320cfc), {
                        hasUserAddedContent: hasUserAddedContent,
                        contentId: contentId,
                        parentPageId: parentPageId,
                        currentSpace: currentSpaceKey
                    })
                }
            ] : []
        ];
    })();
    const panelWidth = (0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false) ? 400 : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lTuad.EditorContextPanelItem), {
        itemName: "template-panel",
        closeSelf: closeConfigPanel,
        customWidth: panelWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fe7ee9063c2de8$var$ContentWrapper, {
        disabled: isPanelDisabled,
        "data-testid": "content-creation-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4A7Gn.default), {
        onChange: handleTabSelect,
        selected: selectedTab,
        id: "editorContextPanelContentCreationTabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fe7ee9063c2de8$var$StickyTabsHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a9fe7ee9063c2de8$var$closeIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5gk7.CloseButton), {
        onClose: closeConfigPanel,
        label: intl.formatMessage($a9fe7ee9063c2de8$export$a7357cdd1f0b0168.closeLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0DTaW.default), null, tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gCbPZ.default), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), tab.label))))), tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9fe7ee9063c2de8$var$CustomTabPanel, {
            key: index
        }, tab.content))))));
};



const $2f3d6b030a611bed$export$aaff6b6704dfdcef = /*#__PURE__*/ (0, $42omo.memo)(({ hasUserAddedContent: hasUserAddedContent, isPanelDisabled: isPanelDisabled, title: title, onContentUpdated: onContentUpdated, beforeTemplateSelect: beforeTemplateSelect, isContentCreationPanelShown: isContentCreationPanelShown, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, beforeUpdateRequest: beforeUpdateRequest, onError: onError, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    (0, $f0ac822d8f33c68a$export$55a4b363793a10d0)(isContentCreationPanelShown, contentId);
    const { abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences } = (0, $3c4a4cbc3a864190$export$b6c47fafdd5a8f13)();
    const subExperiences = (0, $42omo.useMemo)(()=>(0, $97753ca4d20e5422$export$592985e5f8127ac4)(isSpacePickerDisabled), [
        isSpacePickerDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isContentCreationPanelShown) abortTemplatePanelLoadExperiences('closing template panel');
    }, [
        isContentCreationPanelShown,
        abortTemplatePanelLoadExperiences
    ]);
    if (isContentCreationPanelShown && currentSpaceKey && contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        collect: (0, $97753ca4d20e5422$export$7bbca367109bb861)(subExperiences),
        timeout: (0, $aJPUt.ExperienceTimeout).IN_EDITOR_TEMPLATE_PANEL_LOAD
    }), subExperiences.map((name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: name,
            key: name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $9qW65.IN_EDITOR_TEMPLATES_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9fe7ee9063c2de8$export$ea9a941ad7141159), {
        currentSpaceKey: currentSpaceKey,
        contentId: contentId,
        title: title,
        onContentUpdated: onContentUpdated,
        isPanelDisabled: isPanelDisabled,
        beforeTemplateSelect: beforeTemplateSelect,
        hasUserAddedContent: hasUserAddedContent,
        beforeUpdateRequest: beforeUpdateRequest,
        onError: onError,
        closeConfigPanel: onClickCloseContentCreationPanel,
        abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences,
        templateAllowList: templateAllowList,
        isImportDisabled: isImportDisabled,
        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
        isSpacePickerDisabled: isSpacePickerDisabled
    }));
    return null;
});



var $3jwuS = parcelRequire("3jwuS");


var $i9VoI = parcelRequire("i9VoI");

















var $1NBp8 = parcelRequire("1NBp8");








var $3IZob = parcelRequire("3IZob");







const $0c83309d3c4c183d$var$POST_BE_SYNCHRONOUS_REFRESH_EDITOR_TIMEOUT = 1500;
const $0c83309d3c4c183d$var$DELAY_INITIAL_CHECK_TIMEOUT = 4000;
const $0c83309d3c4c183d$var$isContentCreationPanelOpen = (getQueryParams)=>{
    return (0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen)(getQueryParams);
};
const $0c83309d3c4c183d$export$d0c9d99895e9eacb = ({ cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, contentId: contentId, draftShareId: draftShareId, editorActions: editorActions, hideSpinner: hideSpinner, showSpinner: showSpinner, isUnpublishedDraft: isUnpublishedDraft, isEmbeddedEditor: isEmbeddedEditor })=>{
    const { setQueryParams: setQueryParams, getQueryParams: getQueryParams, replace: replace } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const _skipLocalChangesCheck = (0, $42omo.useRef)((0, $lJDEI.getCreatedWithTemplateQueryParamValue)(getQueryParams));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [hasUserAddedContent, setHasUserAddedContent] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            _skipLocalChangesCheck.current = false;
        }, $0c83309d3c4c183d$var$DELAY_INITIAL_CHECK_TIMEOUT);
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    const onDocChange = (0, $42omo.useCallback)(()=>{
        const editorHasContent = !editorActions.isDocumentEmpty();
        const wasTemplatesPanelAutoClosed = (0, $lJDEI.getInEditorTemplatesPanelQueryParamValue)(getQueryParams) === (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED);
        if (isUnpublishedDraft && !editorHasContent && wasTemplatesPanelAutoClosed) (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN));
        if (!_skipLocalChangesCheck.current) {
            if ((0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpen)(getQueryParams) && editorHasContent) setQueryParams({
                [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED),
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: null
            }, true);
            setHasUserAddedContent(editorHasContent);
        }
    }, [
        editorActions,
        _skipLocalChangesCheck,
        getQueryParams,
        setQueryParams,
        isUnpublishedDraft
    ]);
    (0, $42omo.useEffect)(()=>{
        subscribeDocChange(onDocChange);
        return ()=>unsubscribeDocChange(onDocChange);
    }, [
        onDocChange
    ]);
    const onClickCloseContentCreationPanel = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'templateDrawer',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateDismissButton'
            }
        }).fire();
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams);
    }, [
        setQueryParams,
        createAnalyticsEvent
    ]);
    const onClickOpenContentCreationPanel = (0, $42omo.useCallback)((panelMode)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'dropdownMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: panelMode === (0, $lJDEI.PANEL_MODE_IMPORT) ? 'openImportBrowser' : 'openTemplateBrowser'
            }
        }).fire();
        const tabTarget = panelMode === (0, $lJDEI.PANEL_MODE_IMPORT) ? (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT) : (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES);
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN), tabTarget);
    }, [
        setQueryParams,
        createAnalyticsEvent
    ]);
    const beforeUpdateRequest = (0, $42omo.useCallback)(()=>{
        showSpinner();
        cancelDebouncedSaveDraft();
        _skipLocalChangesCheck.current = true;
    }, [
        showSpinner,
        cancelDebouncedSaveDraft,
        _skipLocalChangesCheck
    ]);
    const postUpdateRequest = (0, $42omo.useCallback)(()=>{
        setHasUserAddedContent(false);
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN));
        setTimeout(()=>{
            _skipLocalChangesCheck.current = false;
            hideSpinner();
        }, $0c83309d3c4c183d$var$POST_BE_SYNCHRONOUS_REFRESH_EDITOR_TIMEOUT);
    }, [
        hideSpinner,
        _skipLocalChangesCheck,
        setQueryParams
    ]);
    const handleUpdatedWithTemplate = (0, $42omo.useCallback)(async (payload)=>{
        try {
            showSpinner();
            experienceTracker.start({
                name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
            });
            const { spaceKey: spaceKey, subType: subType } = payload;
            await (0, $8rj8Z.refetchEditorContent)(contentId);
            let route;
            let query = draftShareId ? {
                draftShareId: draftShareId
            } : {};
            if (isEmbeddedEditor) {
                route = (0, $1NBp8.EDIT_PAGE_EMBED);
                const params = getQueryParams();
                query = {
                    ...query,
                    ...params
                };
            } else if (subType === 'live') {
                route = (0, $1NBp8.VIEW_PAGE);
                // Since live page don't have the concept of drafts, draftShareId is not needed
                query = {};
            } else route = (0, $1NBp8.EDIT_PAGE_V2);
            replace(route.toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: 'pages'
            }, {
                query: query
            }));
            experienceTracker.succeed({
                name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE)
            });
            experienceTracker.succeed({
                name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE)
            });
        } catch (error) {
            if (error instanceof Error) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE),
                    error: error
                });
                experienceTracker.stopOnError({
                    name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE),
                    error: error
                });
            }
        } finally{
            hideSpinner();
        }
    }, [
        contentId,
        cancelDebouncedSaveDraft,
        draftShareId,
        experienceTracker,
        showSpinner,
        hideSpinner,
        replace,
        isEmbeddedEditor,
        getQueryParams
    ]);
    const onUpdatedWithTemplateSubscriptionEvent = (0, $42omo.useCallback)(async (response)=>{
        cancelDebouncedSaveDraft();
        await handleUpdatedWithTemplate({
            spaceKey: response?.contentUpdatedWithTemplate?.spaceKey,
            subType: response?.contentUpdatedWithTemplate?.subtype
        });
    }, []);
    // Derive the current panel mode from query params
    // 'import' => 'import' mode, 'templates' or 'block' => 'templates' mode
    let contentCreationPanelMode;
    if ((0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false)) {
        const queryParams = getQueryParams();
        const contextPanelTabTarget = queryParams[0, $lJDEI.CONTEXT_PANEL_TAB_TARGET];
        if (contextPanelTabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK) || contextPanelTabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES)) contentCreationPanelMode = (0, $lJDEI.PANEL_MODE_TEMPLATES);
        else if (contextPanelTabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT)) contentCreationPanelMode = (0, $lJDEI.PANEL_MODE_IMPORT);
    }
    return {
        beforeUpdateRequest: beforeUpdateRequest,
        hasUserAddedContent: hasUserAddedContent,
        isContentCreationPanelOpen: $0c83309d3c4c183d$var$isContentCreationPanelOpen(getQueryParams),
        contentCreationPanelMode: contentCreationPanelMode,
        onDocChange: onDocChange,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        postUpdateRequest: postUpdateRequest,
        onUpdatedWithTemplateSubscriptionEvent: onUpdatedWithTemplateSubscriptionEvent
    };
};


const $bc4a316d21499c5a$var$renderContextPanelContentCreationPanel = (0, $2XqLN.default)(({ cancelDebouncedSaveDraft: // TODO: canPublish is used for isPanelDisabled, but and it includes a permission check in
// addition to collab init check which needs to be added for NativeCollab
// canPublish
cancelDebouncedSaveDraft, contentType: contentType, collabEditInitialized: collabEditInitialized, beforeUpdateRequest: beforeUpdateRequest, recoverAndRefreshEditorContent: recoverAndRefreshEditorContent, hideSpinner: hideSpinner, hasUserAddedContent: hasUserAddedContent, isUnpublishedDraft: isUnpublishedDraft, isContentCreationPanelOpen: isContentCreationPanelOpen, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, renderPanel: renderPanel, title: title, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled, isLivePage: isLivePage })=>{
    // Render the templates content-creation panel for drafts + live pages by default.
    // For published pages, we only render it when `cc_snippets_dogfooding` is enabled.
    const _renderPanel = renderPanel && contentType === 'page' && (isUnpublishedDraft || isLivePage || (0, $6mKj3.expVal)('cc_snippets_dogfooding', 'isEnabled', false));
    if (_renderPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2f3d6b030a611bed$export$aaff6b6704dfdcef), {
        hasUserAddedContent: hasUserAddedContent,
        isPanelDisabled: !collabEditInitialized,
        title: title,
        onContentUpdated: recoverAndRefreshEditorContent,
        beforeUpdateRequest: beforeUpdateRequest,
        beforeTemplateSelect: cancelDebouncedSaveDraft,
        isContentCreationPanelShown: isContentCreationPanelOpen,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        onError: hideSpinner,
        templateAllowList: templateAllowList,
        isImportDisabled: isImportDisabled,
        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
        isSpacePickerDisabled: isSpacePickerDisabled
    });
    return null;
});
const $bc4a316d21499c5a$export$4b19e5011403af51 = ({ children: children, cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, collabEditInitialized: collabEditInitialized, contentId: contentId, contentType: contentType, draftShareId: draftShareId, editorActions: editorActions, hideSpinner: hideSpinner, isUnpublishedDraft: isUnpublishedDraft, renderPanel: renderPanel, showSpinner: showSpinner, title: title, isEmbeddedEditor: isEmbeddedEditor, templateAllowList: templateAllowList, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const { beforeUpdateRequest: beforeUpdateRequest, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, postUpdateRequest: postUpdateRequest, hasUserAddedContent: hasUserAddedContent, isContentCreationPanelOpen: isContentCreationPanelOpen, contentCreationPanelMode: contentCreationPanelMode, onUpdatedWithTemplateSubscriptionEvent: onUpdatedWithTemplateSubscriptionEvent } = (0, $0c83309d3c4c183d$export$d0c9d99895e9eacb)({
        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
        contentId: contentId,
        draftShareId: draftShareId,
        editorActions: editorActions,
        hideSpinner: hideSpinner,
        showSpinner: showSpinner,
        isUnpublishedDraft: isUnpublishedDraft,
        isEmbeddedEditor: isEmbeddedEditor
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const pubSubResourceType = contentType || 'page';
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorContextPanelPageUpdatedWithTemplateSubscription',
        contentId: contentId,
        delta: 'contentUpdatedWithTemplate',
        contentType: pubSubResourceType,
        onDataReceived: onUpdatedWithTemplateSubscriptionEvent
    });
    const recoverAndRefreshEditorContent = (0, $42omo.useCallback)(async ()=>{
        await (0, $8rj8Z.refetchEditorContent)(contentId);
        postUpdateRequest();
    }, [
        contentId,
        postUpdateRequest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children({
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        contentCreationPanelMode: contentCreationPanelMode,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        beforeUpdateRequest: beforeUpdateRequest,
        postUpdateRequest: postUpdateRequest
    }), $bc4a316d21499c5a$var$renderContextPanelContentCreationPanel({
        cancelDebouncedSaveDraft: // canPublish,
        cancelDebouncedSaveDraft,
        collabEditInitialized: collabEditInitialized,
        contentType: contentType,
        beforeUpdateRequest: beforeUpdateRequest,
        recoverAndRefreshEditorContent: recoverAndRefreshEditorContent,
        hasUserAddedContent: hasUserAddedContent,
        isUnpublishedDraft: isUnpublishedDraft,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        hideSpinner: hideSpinner,
        renderPanel: renderPanel,
        title: title,
        templateAllowList: templateAllowList,
        isImportDisabled: isEmbeddedEditor,
        isAlwaysDiscardChanges: isEmbeddedEditor,
        isSpacePickerDisabled: isSpacePickerDisabled,
        isLivePage: isLivePage
    }));
};
module.exports["EditorContextContentCreationPanelWrapper"] = $bc4a316d21499c5a$export$4b19e5011403af51;

});

parcelRegister("8rj8Z", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $l1kdf = parcelRequire("l1kdf");

const $87f902552c64bfd1$export$afadd31735d9bb64 = async (contentId)=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        return await (0, $hp2SH.getApolloClient)().query({
            query: (0, $l1kdf.NativeCollabQuery),
            context: {
                single: true
            },
            fetchPolicy: 'network-only',
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ]
            }
        });
    } catch (error) {
    // NOTE: We intentionally swallow any possible error here as this query is only aimed
    // populate the cache with just published content. Should any error occur here after
    // successful publishing the page, the Apollo cache for the query will be invalidated
    // anyway and View Page will fetch the page and handle possible errors.
    }
};
module.exports["refetchEditorContent"] = $87f902552c64bfd1$export$afadd31735d9bb64;

});

parcelRegister("9qW65", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $42c7f09509682fdc$export$de9c4920d9307bee = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.IN_EDITOR_TEMPLATES_SEGMENT_KEY)
});
module.exports["IN_EDITOR_TEMPLATES_METRIC"] = $42c7f09509682fdc$export$de9c4920d9307bee;

});

parcelRegister("4vs03", function(module, exports) {

let $347fc6e42f2d8f23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $347fc6e42f2d8f23$var$load("a5UQo"),
    $347fc6e42f2d8f23$var$load("6G4QQ")
]).then(()=>parcelRequire('dzOK8'));

});

parcelRegister("f5Xhw", function(module, exports) {

let $afd54ebaa9839d36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $afd54ebaa9839d36$var$load("52kTj").then(()=>parcelRequire('4eC1j'));

});

parcelRegister("d8dIT", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $hkl5F = parcelRequire("hkl5F");

var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $dn4ZF = parcelRequire("dn4ZF");


var $cO1el = parcelRequire("cO1el");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $804cB = parcelRequire("804cB");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $4noo5 = parcelRequire("4noo5");


var $9EtP6 = parcelRequire("9EtP6");


var $hEeUR = parcelRequire("hEeUR");


var $lsxnT = parcelRequire("lsxnT");


var $7aRa9 = parcelRequire("7aRa9");


var $e9jnk = parcelRequire("e9jnk");


var $dZUkS = parcelRequire("dZUkS");


var $iGTD6 = parcelRequire("iGTD6");

const $717633349732e5c8$var$EMPTY_ADF = {
    type: 'doc',
    version: 1,
    content: []
};
const $717633349732e5c8$export$93264818345214c8 = 60;
const $717633349732e5c8$export$4e4fc3c1312865b2 = 120;
var $717633349732e5c8$export$95aec9f342846efe = /*#__PURE__*/ function(SnippetEditorModalEvents) {
    SnippetEditorModalEvents["CANCELLED"] = "snippetEditorModalCancelled";
    SnippetEditorModalEvents["CLOSED"] = "snippetEditorModalClosed";
    SnippetEditorModalEvents["CREATED"] = "snippetEditorModalCreated";
    SnippetEditorModalEvents["EDITED"] = "snippetEditorModalEdited";
    return SnippetEditorModalEvents;
}({});
const $717633349732e5c8$var$styles = {
    modalContent: "_2rkopb1k _bfhkhfxm",
    bodyWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _4t3i1us8",
    bodyContainer: "_zulppxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _18zr1b66 _1e0c1txw _2lx2vrvc _ca0qutpp _n3tdpxbi _vchhusvi",
    headerContainer: "_ca0qutpp _19bvxy5q _u5f31ejb _1o9zidpf",
    previewColumn: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rkopb1k _v5641kuu _1reo1wug _18m91wug _1yt41ejb _4t3i1osq _bfhkvuon _16qst7xp",
    formColumn: "_2rkopb1k _v5641kuu _1yt41ejb _1reo15vq _18m915vq _1bsbnklw _1ul9nklw _1o9zidpf _bfhkvuon _16qst7xp _1e0c1txw _2lx21bp4",
    formContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
    formFields: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    formActions: "_1o9zidpf _ca0qpxbi"
}; // TODO: remove this function when start using the editor instead of the renderer
// For ADFRenderer to work, we need to normalize the ADF to a doc node and saved snippet body maybe not always a doc node
function $717633349732e5c8$var$normalizeToDoc(adf) {
    if (!adf) return $717633349732e5c8$var$EMPTY_ADF;
    if (Array.isArray(adf)) return {
        type: 'doc',
        version: 1,
        content: adf
    };
    if (adf.type === 'doc' && Array.isArray(adf.content)) return {
        type: 'doc',
        version: 1,
        content: adf.content
    };
    return {
        type: 'doc',
        version: 1,
        content: [
            adf
        ]
    };
}
function $717633349732e5c8$var$getPreviewAdf(mode, snippet, adf) {
    const source = mode === (0, $e9jnk.SnippetEditorModalMode).EDIT && snippet?.body ? snippet.body : adf;
    return $717633349732e5c8$var$normalizeToDoc(source);
}
function $717633349732e5c8$var$getDefaultFormValues(mode, snippet) {
    if (mode === (0, $e9jnk.SnippetEditorModalMode).EDIT && snippet) return {
        snippetName: snippet.name ?? '',
        snippetDescription: snippet.description ?? ''
    };
    return {
        snippetName: '',
        snippetDescription: ''
    };
}
const $717633349732e5c8$var$SnippetEditorModalHeader = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { title: title, onClose: onClose } = t0;
    const { titleId: titleId } = (0, $804cB.useModal)();
    let t1;
    if ($[0] !== title || $[1] !== titleId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "small",
            id: titleId
        }, title);
        $[0] = title;
        $[1] = titleId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== onClose) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            onClick: onClose
        });
        $[3] = onClose;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignInline: "center",
            spread: "space-between",
            alignBlock: "center",
            xcss: $717633349732e5c8$var$styles.headerContainer
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $717633349732e5c8$var$SnippetEditorModalWithFlags = (t0)=>{
    const $ = (0, $frIzR.c)(53);
    const { mode: mode, adf: adf, snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, editorAPI: editorAPI, flags: flags } = t0;
    const [adfError, setADFError] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const intl = (0, $8C5kA.default)();
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (event)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "confluenceSnippetEditorModal",
                    action: "closed",
                    actionSubject: "button",
                    actionSubjectId: "snippetEditor",
                    type: "ui",
                    attributes: {
                        event: event
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const fireSnippetEditorModalAnalytics = t1;
    let t2;
    if ($[2] !== adf || $[3] !== mode || $[4] !== snippet) {
        t2 = $717633349732e5c8$var$getPreviewAdf(mode, snippet, adf);
        $[2] = adf;
        $[3] = mode;
        $[4] = snippet;
        $[5] = t2;
    } else t2 = $[5];
    const previewAdf = t2;
    let t3;
    if ($[6] !== mode || $[7] !== snippet) {
        t3 = $717633349732e5c8$var$getDefaultFormValues(mode, snippet);
        $[6] = mode;
        $[7] = snippet;
        $[8] = t3;
    } else t3 = $[8];
    const defaultValues = t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (error)=>{
            setADFError(error);
        };
        $[9] = t4;
    } else t4 = $[9];
    const handleADFError = t4;
    let t5;
    if ($[10] !== fireSnippetEditorModalAnalytics || $[11] !== onClose) {
        t5 = (event_0)=>{
            fireSnippetEditorModalAnalytics(event_0);
            onClose();
        };
        $[10] = fireSnippetEditorModalAnalytics;
        $[11] = onClose;
        $[12] = t5;
    } else t5 = $[12];
    const handleClose = t5;
    let t6;
    if ($[13] !== editorAPI || $[14] !== flags || $[15] !== handleClose || $[16] !== intl || $[17] !== mode || $[18] !== previewAdf || $[19] !== snippet || $[20] !== snippetsActions) {
        t6 = async (values)=>{
            if (!flags) return;
            if (mode === (0, $e9jnk.SnippetEditorModalMode).CREATE) {
                const newSnippet = await snippetsActions.createSnippet(values.snippetName, previewAdf, values.snippetDescription, {
                    flags: flags,
                    intl: intl,
                    editorAPI: editorAPI
                });
                if (newSnippet) handleClose("snippetEditorModalCreated");
            } else {
                if (!snippet) return;
                const updatedSnippet = await snippetsActions.updateSnippet(snippet.snippetId, values.snippetName, previewAdf, values.snippetDescription, {
                    flags: flags,
                    intl: intl,
                    editorAPI: editorAPI
                });
                if (updatedSnippet) handleClose("snippetEditorModalEdited");
            }
        };
        $[13] = editorAPI;
        $[14] = flags;
        $[15] = handleClose;
        $[16] = intl;
        $[17] = mode;
        $[18] = previewAdf;
        $[19] = snippet;
        $[20] = snippetsActions;
        $[21] = t6;
    } else t6 = $[21];
    const submit = t6;
    let t7;
    if ($[22] !== mode) {
        t7 = mode === (0, $e9jnk.SnippetEditorModalMode).EDIT ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iGTD6.messages).snippetEditorModalTitleEdit) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iGTD6.messages).snippetEditorModalTitleCreate);
        $[22] = mode;
        $[23] = t7;
    } else t7 = $[23];
    const title = t7;
    let t8;
    if ($[24] !== mode) {
        t8 = mode === (0, $e9jnk.SnippetEditorModalMode).EDIT ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iGTD6.messages).snippetEditorModalSaveButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iGTD6.messages).snippetEditorModalCreateButton);
        $[24] = mode;
        $[25] = t8;
    } else t8 = $[25];
    const submitLabel = t8;
    let t9;
    if ($[26] !== handleClose) {
        t9 = ()=>handleClose("snippetEditorModalClosed");
        $[26] = handleClose;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== handleClose) {
        t10 = ()=>handleClose("snippetEditorModalClosed");
        $[28] = handleClose;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== t10 || $[31] !== title) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($717633349732e5c8$var$SnippetEditorModalHeader, {
            title: title,
            onClose: t10
        });
        $[30] = t10;
        $[31] = title;
        $[32] = t11;
    } else t11 = $[32];
    const t12 = mode === (0, $e9jnk.SnippetEditorModalMode).EDIT && snippet ? snippet.snippetId : (0, $e9jnk.SnippetEditorModalMode).CREATE;
    let t13;
    if ($[33] !== adfError || $[34] !== defaultValues.snippetDescription || $[35] !== defaultValues.snippetName || $[36] !== handleClose || $[37] !== intl || $[38] !== previewAdf || $[39] !== submitLabel) {
        t13 = (t14)=>{
            const { submitting: submitting, formProps: formProps } = t14;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
                ...formProps,
                className: (0, $gMc0m.default)([
                    $717633349732e5c8$var$styles.formContainer
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $717633349732e5c8$var$styles.bodyWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $717633349732e5c8$var$styles.bodyContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $717633349732e5c8$var$styles.previewColumn
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
                document: previewAdf,
                appearance: "comment",
                allowPlaceholderText: true,
                onError: handleADFError
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $717633349732e5c8$var$styles.formColumn
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.300",
                xcss: $717633349732e5c8$var$styles.formFields
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
                name: "snippetName",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iGTD6.messages).snippetEditorModalNameLabel),
                defaultValue: defaultValues.snippetName,
                component: (t15)=>{
                    const { fieldProps: fieldProps } = t15;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                        ...fieldProps,
                        maxLength: $717633349732e5c8$export$93264818345214c8,
                        placeholder: intl.formatMessage((0, $iGTD6.messages).snippetEditorModalNamePlaceholder)
                    });
                },
                validate: (value)=>value ? undefined : intl.formatMessage((0, $iGTD6.messages).snippetEditorModalNameError),
                isRequired: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkl5F.default), {
                name: "snippetDescription",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iGTD6.messages).snippetEditorModalDescriptionLabel),
                defaultValue: defaultValues.snippetDescription,
                maxCharacters: $717633349732e5c8$export$4e4fc3c1312865b2
            }, (t16)=>{
                const { fieldProps: fieldProps_0 } = t16;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
                    ...fieldProps_0,
                    placeholder: intl.formatMessage((0, $iGTD6.messages).snippetEditorModalDescriptionPlaceholder)
                });
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
                name: "snippetBody",
                defaultValue: adfError,
                validate: ()=>adfError ? intl.formatMessage((0, $iGTD6.messages).snippetEditorModalAdfError) : undefined
            }, $717633349732e5c8$var$_temp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $717633349732e5c8$var$styles.formActions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dn4ZF.default), {
                align: "end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: ()=>handleClose("snippetEditorModalCancelled")
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $iGTD6.messages).snippetEditorModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, submitLabel)))))))));
        };
        $[33] = adfError;
        $[34] = defaultValues.snippetDescription;
        $[35] = defaultValues.snippetName;
        $[36] = handleClose;
        $[37] = intl;
        $[38] = previewAdf;
        $[39] = submitLabel;
        $[40] = t13;
    } else t13 = $[40];
    let t14;
    if ($[41] !== submit || $[42] !== t12 || $[43] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
            key: t12,
            noValidate: true,
            onSubmit: submit
        }, t13);
        $[41] = submit;
        $[42] = t12;
        $[43] = t13;
        $[44] = t14;
    } else t14 = $[44];
    let t15;
    if ($[45] !== t11 || $[46] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $717633349732e5c8$var$styles.modalContent
        }, t11, t14);
        $[45] = t11;
        $[46] = t14;
        $[47] = t15;
    } else t15 = $[47];
    let t16;
    if ($[48] !== Modal || $[49] !== onCloseComplete || $[50] !== t15 || $[51] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            width: "x-large",
            onClose: t9,
            onCloseComplete: onCloseComplete
        }, t15);
        $[48] = Modal;
        $[49] = onCloseComplete;
        $[50] = t15;
        $[51] = t9;
        $[52] = t16;
    } else t16 = $[52];
    return t16;
};
const $717633349732e5c8$export$69d3f38cab30696c = (0, $7aRa9.withFlags)($717633349732e5c8$var$SnippetEditorModalWithFlags);
function $717633349732e5c8$var$_temp(t0) {
    const { error: error_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.MessageWrapper), null, error_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, error_0));
}
module.exports["SnippetEditorModal"] = $717633349732e5c8$export$69d3f38cab30696c;

});

parcelRegister("5IgBW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $4gEXU = parcelRequire("4gEXU");


var $4tTm9 = parcelRequire("4tTm9");


var $3omFm = parcelRequire("3omFm");

const $f7d023b2088a5828$export$a0008e78c876ccee = ()=>{
    const { editorCreateProps: editorCreateProps, editorViewProps: editorViewProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const onConfirm = (0, $42omo.useCallback)(()=>{
        !!editorCreateProps && setEditorCreateProps(null);
        !!editorViewProps && setEditorViewProps(null);
    }, [
        editorCreateProps,
        setEditorCreateProps,
        editorViewProps,
        setEditorViewProps
    ]);
    (0, $4gEXU.usePreemptiveGate)({
        onConfirm: onConfirm
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, editorCreateProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tTm9.CreateComponent), {
        ...editorCreateProps,
        isOffline: isOffline
    }), editorViewProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3omFm.ViewComponent), {
        ...editorViewProps,
        isOffline: isOffline
    }));
};
module.exports["EditorAnnotationProviderComponents"] = $f7d023b2088a5828$export$a0008e78c876ccee;

});

parcelRegister("gKaeO", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fdc21a809c69e224$var$EditorRevertDialogContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $fdc21a809c69e224$export$bb04726afe1ab08f = ({ children: children })=>{
    const [shouldShowRevertDialog, setShouldShowRevertDialog] = (0, $42omo.useState)(false);
    const [shouldShowRevertDialogDiff, setShouldShowRevertDialogDiff] = (0, $42omo.useState)(false);
    const hideRevertDialogDiff = (0, $42omo.useCallback)(()=>setShouldShowRevertDialogDiff(false), []);
    const showRevertDialogDiff = (0, $42omo.useCallback)(()=>setShouldShowRevertDialogDiff(true), []);
    const hideRevertDialog = (0, $42omo.useCallback)(()=>setShouldShowRevertDialog(false), []);
    const showRevertDialog = (0, $42omo.useCallback)(()=>{
        setShouldShowRevertDialog(true);
        setShouldShowRevertDialogDiff(false);
    }, []);
    const editorRevertDialogContextValue = (0, $42omo.useMemo)(()=>({
            shouldShowRevertDialog: shouldShowRevertDialog,
            shouldShowRevertDialogDiff: shouldShowRevertDialogDiff,
            hideRevertDialogDiff: hideRevertDialogDiff,
            showRevertDialogDiff: showRevertDialogDiff,
            hideRevertDialog: hideRevertDialog,
            showRevertDialog: showRevertDialog
        }), [
        shouldShowRevertDialog,
        shouldShowRevertDialogDiff,
        hideRevertDialogDiff,
        showRevertDialogDiff,
        hideRevertDialog,
        showRevertDialog
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdc21a809c69e224$var$EditorRevertDialogContext.Provider, {
        value: editorRevertDialogContextValue
    }, children);
};
const $fdc21a809c69e224$export$6ff48c61ddbf94bf = ()=>{
    const context = (0, $42omo.useContext)($fdc21a809c69e224$var$EditorRevertDialogContext);
    if (context === undefined) throw new Error('EditorRevertDialogContext must be used within an EditorRevertDialogContextProvider');
    return context;
};
function $fdc21a809c69e224$export$bd3b9d76887afd3a(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdc21a809c69e224$export$bb04726afe1ab08f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
}
module.exports["EditorRevertDialogContextProvider"] = $fdc21a809c69e224$export$bb04726afe1ab08f;
module.exports["useEditorRevertDialogContext"] = $fdc21a809c69e224$export$6ff48c61ddbf94bf;
module.exports["withRevertContext"] = $fdc21a809c69e224$export$bd3b9d76887afd3a;

});

parcelRegister("fE1Ao", function(module, exports) {
/** @graphql cc */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $e9owJ = parcelRequire("e9owJ");


var $8G1o2 = parcelRequire("8G1o2");


var $dqLea = parcelRequire("dqLea");


var $l3Dp5 = parcelRequire("l3Dp5");


var $ge2sX = parcelRequire("ge2sX");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $4o1RV = parcelRequire("4o1RV");


var $jacyh = parcelRequire("jacyh");

/* eslint-disable react/no-this-in-sfc */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 



var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $6R5uz = parcelRequire("6R5uz");


var $eEA8O = parcelRequire("eEA8O");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $6xdDU = parcelRequire("6xdDU");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $9hlns = parcelRequire("9hlns");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $kj1gY = parcelRequire("kj1gY");





var $1mHQU = parcelRequire("1mHQU");


var $601vk = parcelRequire("601vk");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");









const $db051ff45b440e81$var$headerStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    fontWeight: 'font.weight.medium',
    padding: 'space.250'
});
const $db051ff45b440e81$export$54ae5c5dd05596de = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "h2",
        xcss: $db051ff45b440e81$var$headerStyles
    }, children);
const $db051ff45b440e81$var$contributorListStyles = (0, $ecnYn.xcss)({
    listStyle: 'none',
    paddingLeft: 'space.0',
    maxHeight: '160px',
    overflowY: 'auto'
});
const $db051ff45b440e81$export$fbf92180ee7fa390 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "ul",
        xcss: $db051ff45b440e81$var$contributorListStyles,
        testId: "editor-revert-dialog-contributors-list"
    }, children);
const $db051ff45b440e81$var$contributorListItemStyles = (0, $ecnYn.xcss)({
    float: 'left',
    width: '50%'
});
const $db051ff45b440e81$export$52d11275ec7751f6 = ({ key: key, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: $db051ff45b440e81$var$contributorListItemStyles,
        key: key
    }, children);
const $db051ff45b440e81$var$avatarStyles = (0, $ecnYn.xcss)({
    filter: 'grayscale(100%)',
    opacity: 0.7,
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.0',
    paddingRight: 'space.0'
});
const $db051ff45b440e81$export$5d6db156164366c9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $db051ff45b440e81$var$avatarStyles
    }, children);
const $db051ff45b440e81$var$avatarImgStyles = (0, $ecnYn.xcss)({
    height: 'size.300',
    borderRadius: 'radius.small'
});
const $db051ff45b440e81$export$62ca698686e2dcfb = ({ src: src, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "img",
        xcss: $db051ff45b440e81$var$avatarImgStyles,
        src: src,
        alt: alt
    });
const $db051ff45b440e81$var$detailStyles = (0, $ecnYn.xcss)({
    display: 'table-cell',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $db051ff45b440e81$export$e214e3696a2038d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $db051ff45b440e81$var$detailStyles
    }, children);
const $db051ff45b440e81$var$detailNameStyles = (0, $ecnYn.xcss)({
    fontWeight: 'font.weight.bold',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '200px',
    overflow: 'hidden'
});
const $db051ff45b440e81$export$8017f73df02c60d6 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "p",
        xcss: $db051ff45b440e81$var$detailNameStyles
    }, children);
const $db051ff45b440e81$var$contributorDetailLastModificationStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    margin: 'space.0',
    font: 'font.body',
    verticalAlign: 'bottom',
    filter: 'grayscale(100%)',
    opacity: 0.6
});
const $db051ff45b440e81$export$b891b51eaabcd719 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "p",
        xcss: $db051ff45b440e81$var$contributorDetailLastModificationStyles
    }, children);
const $db051ff45b440e81$var$linkActionsStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.0',
    marginRight: 'space.0'
});
const $db051ff45b440e81$export$73e5e09f3ced9be5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $db051ff45b440e81$var$linkActionsStyles,
        testId: "editor-revert-dialog-link-actions"
    }, children);


const $99497d85d924fd35$export$dd897410adc66601 = {
    delete: {
        page: {
            one: 'editor.quit-dialog.delete.page.changes.by.one',
            many: 'editor.quit-dialog.delete.page.changes.by.many'
        },
        blogpost: {
            one: 'editor.quit-dialog.delete.blogpost.changes.by.one',
            many: 'editor.quit-dialog.delete.blogpost.changes.by.many'
        }
    },
    revert: {
        page: {
            one: 'editor.quit-dialog.revert.page.changes.by.one',
            many: 'editor.quit-dialog.revert.changes.by.many'
        },
        blogpost: {
            one: 'editor.quit-dialog.revert.blogpost.changes.by.one',
            many: 'editor.quit-dialog.revert.changes.by.many'
        }
    }
};
const $99497d85d924fd35$export$7fddb7b8aca8584f = {
    delete: {
        page: 'editor.quit-dialog.button.delete.page.exit',
        blogpost: 'editor.quit-dialog.button.delete.blog.exit'
    },
    revert: {
        page: 'editor.quit-dialog.button.revert.page.exit',
        blogpost: 'editor.quit-dialog.button.revert.blog.exit'
    }
};


const $0abb7f37a4bc0936$var$JustifyShim = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", props);
const $0abb7f37a4bc0936$var$wrapperSpinnerStyles = (0, $ecnYn.xcss)({
    marginBlock: 'space.600',
    marginInline: 'auto',
    textAlign: 'center'
});
const $0abb7f37a4bc0936$var$WrapperSpinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
    xcss: $0abb7f37a4bc0936$var$wrapperSpinnerStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null));
const $0abb7f37a4bc0936$var$RevertExperienceTracker = ({ children: children, analyticsAttributes: analyticsAttributes })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { current: expTrackerConfig } = (0, $42omo.useRef)({
        name: (0, $irVI7.EDIT_PAGE_REVERT_DRAFT_EXPERIENCE),
        attributes: {
            ...analyticsAttributes,
            isCompanyHub: isCompanyHub
        }
    });
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start(expTrackerConfig);
        return ()=>experienceTracker.abort({
                ...expTrackerConfig,
                reason: 'Modal closed'
            });
    }, [
        experienceTracker,
        expTrackerConfig
    ]);
    return children({
        experienceResolver: (prom)=>prom.then(()=>experienceTracker.succeed(expTrackerConfig)).catch((error)=>{
                experienceTracker.fail({
                    ...expTrackerConfig,
                    error: error
                });
                throw error;
            })
    });
};
const $0abb7f37a4bc0936$var$closeButtonStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100'
});
const $0abb7f37a4bc0936$var$CloseButton = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "span",
        xcss: $0abb7f37a4bc0936$var$closeButtonStyles
    }, children);
const $0abb7f37a4bc0936$var$iconDiffNotShownStyles = (0, $ecnYn.xcss)({
    transform: 'rotate(0deg)',
    transition: '0.2s'
});
const $0abb7f37a4bc0936$var$iconDiffShownStyles = (0, $ecnYn.xcss)({
    transform: 'rotate(90deg)',
    transition: '0.2s'
});
const $0abb7f37a4bc0936$var$DiffExpandIcon = ({ isDiffShown: isDiffShown, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isDiffShown ? $0abb7f37a4bc0936$var$iconDiffShownStyles : $0abb7f37a4bc0936$var$iconDiffNotShownStyles
    }, children);
};
class $0abb7f37a4bc0936$var$EditorRevertDialogComponentClass extends (0, $42omo.PureComponent) {
    render() {
        const { shouldShowRevertDialog: shouldShowRevertDialog, fetchingCollaboratorRelations: fetchingCollaboratorRelations, fetchingTouchedRelations: fetchingTouchedRelations, errorFetchingRelations: errorFetchingRelations, isUnpublishedDraft: isUnpublishedDraft } = this.props;
        if (!shouldShowRevertDialog) return null;
        if (errorFetchingRelations) {
            const errorData = {
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).REVERT_CONTENT_ERROR]: true,
                status: null
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $601vk.EditorErrorFlags), {
                errorData: errorData
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$RevertExperienceTracker, {
            analyticsAttributes: {
                isUnpublishedDraft: isUnpublishedDraft
            }
        }, ({ experienceResolver: experienceResolver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "editor-revert-modal-dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
                onClose: this._handleRevertDialogDismissed
            }, this._renderHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, fetchingCollaboratorRelations || fetchingTouchedRelations ? $0abb7f37a4bc0936$var$WrapperSpinner : this._renderChildren()), this._renderFooter({
                experienceResolver: experienceResolver
            })()))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            submitting: false
        };
        this._handleRevertDialogDismissed = ()=>this.props.hideRevertDialog();
        this._handleRevertDialogSubmitted = ({ experienceResolver: experienceResolver })=>async ()=>{
                this.setState({
                    submitting: true
                });
                const { isUnpublishedDraft: isUnpublishedDraft, deleteContent: deleteContent, revertContent: revertContent, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent } = this.props;
                try {
                    if (isUnpublishedDraft) {
                        triggerAnalyticsEvent('deleteContent');
                        await experienceResolver(deleteContent(contentId));
                    } else {
                        triggerAnalyticsEvent('revertContent');
                        await experienceResolver(revertContent({
                            variables: {
                                contentId: contentId
                            }
                        }));
                    }
                } catch (_err) {
                // TODO show a helpful error message
                }
            };
        this._renderHeader = ()=>{
            const { isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, intl: intl } = this.props;
            const headerContent = isUnpublishedDraft ? contentType === (0, $l3Dp5.ContentTypeType).PAGE ? intl.formatMessage({
                id: "editor.quit-dialog.title.page.delete"
            }) : intl.formatMessage({
                id: "editor.quit-dialog.title.blogpost.delete"
            }) : intl.formatMessage({
                id: "editor.quit-dialog.title.discard"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$54ae5c5dd05596de), null, headerContent);
        };
        this.renderWarningText = (contributorsList)=>{
            const { isUnpublishedDraft: isUnpublishedDraft, contentType: contentType } = this.props;
            const operationType = isUnpublishedDraft ? 'delete' : 'revert';
            const contributionType = contributorsList.length === 0 ? 'one' : 'many';
            const warningTextKey = (0, $99497d85d924fd35$export$dd897410adc66601)[operationType][contentType][contributionType];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: warningTextKey
            });
        };
        this._renderContributorsListSection = (contributorsList)=>{
            const { intl: intl } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$fbf92180ee7fa390), null, contributorsList.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$52d11275ec7751f6), {
                    key: contributor?.source?.accountId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$5d6db156164366c9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$62ca698686e2dcfb), {
                    src: contributor?.source?.profilePicture?.path,
                    alt: ""
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$e214e3696a2038d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$8017f73df02c60d6), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, contributor?.source?.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$b891b51eaabcd719), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage({
                    id: "editor.quit-dialog.last.edited"
                }), ' ', contributor?.relationData?.friendlyCreatedDate)))))));
        };
        this._calculateContributorsList = (collaboratorRelations, touchedRelations)=>{
            const { currentAccountId: currentAccountId } = this.props;
            const collaboratorAccountIds = collaboratorRelations.map((collaboratorRelation)=>collaboratorRelation?.source?.accountId);
            return touchedRelations.filter((touchedRelation)=>collaboratorAccountIds.indexOf(touchedRelation?.source?.accountId) > -1 && touchedRelation?.source?.accountId !== currentAccountId);
        };
        this._getDialogSubmitButtonText = ()=>{
            const { contentType: contentType, intl: intl } = this.props;
            const submitTextKeyMessage = {
                id: (0, $99497d85d924fd35$export$7fddb7b8aca8584f)[this.getCurrentOperationType()][contentType]
            };
            return intl.formatMessage(submitTextKeyMessage);
        };
        this.getCurrentOperationType = ()=>this.props.isUnpublishedDraft ? 'delete' : 'revert';
        this._renderShowDiffToggle = (isDiffShown)=>{
            const { hideRevertDialogDiff: hideRevertDialogDiff, showRevertDialogDiff: showRevertDialogDiff } = this.props;
            // If the diff is currently shown, the toggle action will HIDE the diff. The toggle action should also show the contributors,
            // though this functionality is currently broken (see CFE-3296).
            // If the diff is not currently shown, the toggle action will SHOW the diff.
            const toggleAction = isDiffShown ? hideRevertDialogDiff : showRevertDialogDiff;
            const toggleActionTextId = isDiffShown ? 'editor.quit-dialog.link.hide.diff' : 'editor.quit-dialog.link.show.diff';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db051ff45b440e81$export$73e5e09f3ced9be5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                onClick: toggleAction,
                "aria-expanded": isDiffShown,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$DiffExpandIcon, {
                    isDiffShown: isDiffShown
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    spacing: "spacious",
                    label: "Toggle diff",
                    size: "small"
                }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: toggleActionTextId
            })));
        };
        this._renderChildren = ()=>{
            const { shouldShowRevertDialogDiff: shouldShowRevertDialogDiff, contentId: contentId, isUnpublishedDraft: isUnpublishedDraft, collaboratorRelations: collaboratorRelations, touchedRelations: touchedRelations } = this.props;
            const contributorsList = this._calculateContributorsList(collaboratorRelations, touchedRelations);
            const showDiffToggle = this._renderShowDiffToggle(shouldShowRevertDialogDiff);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, this.renderWarningText(contributorsList)), !isUnpublishedDraft && showDiffToggle, shouldShowRevertDialogDiff ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kj1gY.ChangesDiffLoader), {
                contentId: contentId
            }) : this._renderContributorsListSection(contributorsList));
        };
        this._renderFooter = ({ experienceResolver: experienceResolver })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$JustifyShim, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    "data-testid": "submit-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    isDisabled: this.state.submitting,
                    iconAfter: this.state.submitting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null) : undefined,
                    onClick: this._handleRevertDialogSubmitted({
                        experienceResolver: experienceResolver
                    }),
                    appearance: "primary"
                }, this._getDialogSubmitButtonText())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0abb7f37a4bc0936$var$CloseButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    isDisabled: this.state.submitting,
                    onClick: this._handleRevertDialogDismissed,
                    appearance: "subtle"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    id: "close.name"
                })))));
    }
}
$0abb7f37a4bc0936$var$EditorRevertDialogComponentClass.defaultProps = {
    contentType: (0, $l3Dp5.ContentTypeType).PAGE // Setting default value to help with the type error since contentType can be potentially null
};
const $0abb7f37a4bc0936$export$d21522f1fb83d2e9 = (0, $gmMgo.default)($0abb7f37a4bc0936$var$EditorRevertDialogComponentClass);






var $7Sm4c = parcelRequire("7Sm4c");


var $eZLpN = parcelRequire("eZLpN");


var $aBfpe = parcelRequire("aBfpe");

const $595d7fd58c9684b8$export$6857b025f902bf11 = ({ variables: variables, onCompleted: onCompleted, onError: onError })=>{
    const { relationName: relationName, sourceType: sourceType, targetKey: targetKey, targetStatus: targetStatus } = variables;
    if (!relationName) throw new Error('relationName is missing');
    if (!sourceType) throw new Error('sourceType is missing');
    if (!targetKey) throw new Error('targetKey is missing');
    if (!targetStatus) throw new Error('targetStatus is missing');
    const parseResult = (response)=>{
        const mapSource = (source)=>{
            if (!source) return null;
            return {
                displayName: source.displayName ?? null,
                accountId: source.accountId ?? null,
                profilePicture: source.profilePicture?.path ? {
                    path: source.profilePicture.path
                } : null
            };
        };
        const mapRelationData = (relationData)=>{
            if (!relationData) return null;
            return {
                friendlyCreatedDate: relationData.friendlyCreatedDate ?? null
            };
        };
        return {
            experimentalRelationsForContent: {
                results: response.results.map((result)=>({
                        source: mapSource(result.source),
                        relationData: mapRelationData(result.relationData)
                    }))
            }
        };
    };
    return (0, $eZLpN.useExperimentalLazyQuery)({
        url: `/wiki/rest/api/relation/${relationName}/to/content/${targetKey}/from/${sourceType}/?targetStatus=${targetStatus}&expand=source,relationData`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: parseResult,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: (error)=>{
            // Check if it's a BadStatusError with response status
            if ('response' in error && error.response?.status) {
                const status = error.response.status;
                if (status === 403) return new Error('User does not have permission to view the relationship');
                else if (status === 404) return new Error('Target entity does not exist');
            }
            return new Error('Unknown error');
        }
    });
};


const $f7ea8bf18291e5f2$var$isKnownError = (error)=>{
    return error.graphQLErrors.some((e)=>e.message === 'User does not have permission to view the relationship' || e.message === 'Target entity does not exist');
};
const $f7ea8bf18291e5f2$export$d68df4b88ddb860f = (relationName, contentId, isUnpublishedDraft)=>{
    const variables = {
        relationName: relationName,
        sourceType: 'user',
        targetKey: contentId,
        targetStatus: 'draft'
    };
    const [getRelations, { data: data, loading: loading, error: error }] = (0, $595d7fd58c9684b8$export$6857b025f902bf11)({
        variables: variables
    });
    (0, $42omo.useEffect)(()=>{
        // If we're reverting rather than deleting
        if (!isUnpublishedDraft) getRelations();
    }, [
        isUnpublishedDraft,
        getRelations
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error && $f7ea8bf18291e5f2$var$isKnownError(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return {
        relations: data?.experimentalRelationsForContent?.results ?? [],
        loading: loading,
        error: error
    };
};



var $gKaeO = parcelRequire("gKaeO");




const $8c33294e3d69149a$export$c07c276728bebbbc = (0, $eSUdr.default)`mutation DeleteDraftMutationForRevertDialog($contentId:ID!){deleteContent(contentId:$contentId action:DELETE_DRAFT){contentId}}`;


const $359a22a23ec3fd20$export$8d89725053a04255 = {
    'meeting-notes': true,
    decisions: true,
    'kb-how-to-article': true,
    'file-list': true,
    retrospective: true,
    requirements: true,
    'shared-links': true,
    'kb-troubleshooting-article': true,
    'task-report': true,
    jirareport: true
};


const $92e9616f723b6e02$export$5263310017cc26c7 = (content)=>{
    const labels = content?.metadata?.labels ?? [];
    const blueprintLabel = labels.find((item)=>{
        if (item?.name) return (0, $359a22a23ec3fd20$export$8d89725053a04255)[item.name];
    });
    return blueprintLabel?.name ?? '';
};






var $b4EKK = parcelRequire("b4EKK");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b274159c92aeba75$export$b9d88f4afc1c4fa7 = ({ onCompleted: onCompleted } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: (variables)=>{
            if (!variables.contentId) throw new Error('contentId is missing');
            return `/wiki/rest/collab/1.0/content/${variables?.contentId}/changes/unpublished`;
        },
        method: 'DELETE',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: ()=>({
                experimentalRevertContent: true
            }),
        onCompleted: onCompleted,
        transformError: (error)=>{
            if (error instanceof (0, $hBkCm.BadStatusError)) return (0, $b4EKK.getErrorWithResponse)(new Error(`Failed to revert or delete draft: ${error}`), error?.response);
            return error;
        }
    });
};


const $5f783a6f76a26815$var$EditorRevertDialogContentQuery = (0, $eSUdr.default)`query EditorRevertDialogContentQuery($contentId:ID$status:[String]){content(id:$contentId status:$status){nodes{id type version{number}metadata{labels{id name}}links{webui context}}}}`;
const $5f783a6f76a26815$export$12786e122b13d0cd = (props)=>{
    const { contentId: contentId, isUnpublishedDraft: isUnpublishedDraft } = props;
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)($5f783a6f76a26815$var$EditorRevertDialogContentQuery, {
        variables: {
            contentId: contentId,
            status: [
                isUnpublishedDraft ? 'draft' : 'current'
            ]
        }
    });
    if (loading || error) return null;
    const content = (data?.content?.nodes ?? [])[0] ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5f783a6f76a26815$var$EditorRevertDialogContainer, {
        ...props,
        content: content
    });
};
const $5f783a6f76a26815$var$EditorRevertDialogContainer = (props)=>{
    const { relations: collaborators, loading: fetchingCollaboratorRelations, error: errorFetchingCollaborators } = (0, $f7ea8bf18291e5f2$export$d68df4b88ddb860f)('collaborator', props.contentId, props.isUnpublishedDraft);
    const { relations: touched, loading: fetchingTouchedRelations, error: errorFetchingTouched } = (0, $f7ea8bf18291e5f2$export$d68df4b88ddb860f)('touched', props.contentId, props.isUnpublishedDraft);
    const analyticsData = {
        blueprintType: (0, $92e9616f723b6e02$export$5263310017cc26c7)(props.content),
        contentId: props.contentId,
        contentType: props.content?.type ?? '',
        spaceKey: props.spaceKey,
        version: props.content?.version?.number ?? undefined,
        source: 'next-EditorRevertDialogComponent',
        subject: 'revertOrDeleteDialog'
    };
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)(analyticsData);
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const { matchSupportedRoute: matchSupportedRoute, push: push, replace: replace, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const shouldPushInSelf = (path)=>{
        return !routePolicy || routePolicy.willPushInSelf(match?.name, match?.params.contentId, path, undefined);
    };
    const { shouldShowRevertDialog: shouldShowRevertDialog, shouldShowRevertDialogDiff: shouldShowRevertDialogDiff, hideRevertDialogDiff: hideRevertDialogDiff, showRevertDialogDiff: showRevertDialogDiff, hideRevertDialog: hideRevertDialog } = (0, $gKaeO.useEditorRevertDialogContext)();
    const mutationVars = {
        contentId: props.contentId
    };
    const onCompleted = (data)=>{
        if (data.experimentalRevertContent) {
            hideRevertDialog();
            const viewPagePath = (props.content?.links?.context ?? '') + (props.content?.links?.webui ?? '');
            props.cancelDebouncedSaveDraft?.();
            if (shouldPushInSelf(matchSupportedRoute(viewPagePath))) {
                if (viewPagePath !== '') push(viewPagePath);
            }
        }
    };
    const [revertContent] = (0, $b274159c92aeba75$export$b9d88f4afc1c4fa7)({
        onCompleted: onCompleted
    });
    const [deleteContent] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $8c33294e3d69149a$export$c07c276728bebbbc), {
        variables: mutationVars,
        onCompleted: (data)=>{
            if (data.deleteContent.contentId) {
                const route = getAncestorRoute(props.spaceKey);
                hideRevertDialog();
                props.cancelDebouncedSaveDraft?.();
                if (shouldPushInSelf(route)) replace(route);
                if (props.content?.type === (0, $l3Dp5.ContentTypeType).BLOGPOST) // update blog tree after unpublished blog draft is deleted
                forceRefetchBlogTree();
            }
        }
    });
    const errorFetchingRelations = errorFetchingCollaborators !== undefined || errorFetchingTouched !== undefined;
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(props.contentId);
    const getAncestorRoute = (spaceKey)=>{
        // Gets the nearest ancestor in breadcrumbs. Use space index as fallback route in case of error or if page is a blog
        let url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
        if (props.content?.type === (0, $l3Dp5.ContentTypeType).PAGE && breadcrumbs) url = (0, $dqLea.getNearestVisibleAncestor)({
            breadcrumbs: breadcrumbs,
            fallbackUrl: url
        });
        return url;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0abb7f37a4bc0936$export$d21522f1fb83d2e9), {
            content: props.content,
            contentId: props.contentId,
            isUnpublishedDraft: props.isUnpublishedDraft,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            collaboratorRelations: collaborators,
            touchedRelations: touched,
            fetchingCollaboratorRelations: fetchingCollaboratorRelations,
            fetchingTouchedRelations: fetchingTouchedRelations,
            shouldShowRevertDialog: shouldShowRevertDialog,
            shouldShowRevertDialogDiff: shouldShowRevertDialogDiff,
            hideRevertDialogDiff: hideRevertDialogDiff,
            showRevertDialogDiff: showRevertDialogDiff,
            hideRevertDialog: hideRevertDialog,
            errorFetchingRelations: errorFetchingRelations,
            revertContent: revertContent,
            deleteContent: deleteContent,
            currentAccountId: sessionData.userId,
            contentType: props.content?.type
        }));
};
module.exports["EditorRevertDialog"] = $5f783a6f76a26815$export$12786e122b13d0cd;

});

parcelRegister("3wSkK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $3sFtD = parcelRequire("3sFtD");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $bT0se = parcelRequire("bT0se");


var $g01A4 = parcelRequire("g01A4");


var $6mKj3 = parcelRequire("6mKj3");


var $4VJDS = parcelRequire("4VJDS");


var $9wGTI = parcelRequire("9wGTI");


var $18HQ4 = parcelRequire("18HQ4");


var $kVuKK = parcelRequire("kVuKK");

const $a527c2e06cc0891d$var$AnimatedEllipsis = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.EllipsisContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null));
const $a527c2e06cc0891d$var$EditorConnectionBannerComponent = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})((0, $gmMgo.default)(({ editorType: editorType, triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut = false, willEditorDisable: willEditorDisable = false, contentType: contentType, contentId: contentId, isEditorToolbarHidden: isEditorToolbarHidden, intl: { formatMessage: formatMessage } })=>{
    const [showIndicator, setShowIndicator] = (0, $42omo.useState)(false);
    const [restrictionUpdate, setRestrictionUpdate] = (0, $42omo.useState)(false);
    // initialize offlineData with defaults
    const offlineData = (0, $42omo.useRef)({
        browserNetworkStatus: true,
        documentVisibilityState: '',
        connectionTimeoutStartTime: 0,
        offlineStartTime: 0
    });
    const onRestrictionUpdated = (0, $42omo.useCallback)(()=>{
        triggerAnalyticsEvent('offline.banner.restriction.updated', {
            editorType: editorType,
            restrictionUpdate: restrictionUpdate
        });
        return editorType === 'classic' && setRestrictionUpdate(true);
    }, [
        editorType,
        restrictionUpdate,
        triggerAnalyticsEvent
    ]);
    const onRestrictionUpdatedPubSubEvent = (0, $42omo.useCallback)(()=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '')) || !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false)) onRestrictionUpdated();
    }, [
        onRestrictionUpdated
    ]);
    const toggleIndicator = (0, $42omo.useCallback)((indicatorToggleCondition, showIndicatorCallback, hideIndicatorCallback)=>{
        let hideTimeout;
        let delayTimeout;
        const HIDE_FLAG_TIMEOUT = 3000;
        const DELAY_TIMEOUT = 3000;
        if (indicatorToggleCondition) delayTimeout = setTimeout(()=>{
            if (showIndicatorCallback) showIndicatorCallback();
            return setShowIndicator(true);
        }, DELAY_TIMEOUT);
        else hideTimeout = setTimeout(()=>{
            if (hideIndicatorCallback) hideIndicatorCallback();
            //hide show indicator only when both disabling conditions are false
            //to handle edge case where both banners got set to true but we want
            // to be able to show connected banner when restored
            if (!collabEditInternetLost && !collabEditConnectionTimedOut) return setShowIndicator(false);
        }, HIDE_FLAG_TIMEOUT);
        return {
            hideTimeout: hideTimeout,
            delayTimeout: delayTimeout
        };
    }, [
        collabEditConnectionTimedOut,
        collabEditInternetLost
    ]);
    // Upon receiving a permission change pubsub event, prepare the banner to show alternative text
    // Note: Only classic (Synchrony) editor gets offline and back online due to permission changes
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: contentType,
        eventName: `restrictionUpdated:${contentType}`,
        onEvent: onRestrictionUpdatedPubSubEvent,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $g01A4.useContentRestrictionSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        callback: onRestrictionUpdated,
        subscriberId: 'EditorConnectionBannerSubscription'
    });
    (0, $42omo.useEffect)(()=>{
        if (!willEditorDisable) // Reset restriction update boolean upon editor re-connection so next time editor goes offline it will show default messages
        setRestrictionUpdate(false);
    }, [
        willEditorDisable
    ]);
    (0, $42omo.useEffect)(()=>{
        const showIndicatorCB = ()=>{
            // save browser network status, start time of banner display, and document visibility state when user goes offline
            offlineData.current = {
                browserNetworkStatus: navigator.onLine,
                documentVisibilityState: document.visibilityState,
                offlineStartTime: performance.now()
            };
            triggerAnalyticsEvent('offline.banner.show.indicator', {
                editorType: editorType,
                restrictionUpdate: restrictionUpdate
            });
        };
        const hideIndicatorCB = ()=>{
            if (showIndicator) // if offline banner was displayed, fire analytics
            triggerAnalyticsEvent('offline.banner.displayed', {
                browserNetworkStatus: offlineData?.current.browserNetworkStatus,
                editorType: editorType,
                documentVisibilityState: offlineData?.current.documentVisibilityState,
                duration: offlineData?.current.offlineStartTime ? performance.now() - offlineData?.current.offlineStartTime : 0
            });
        };
        const { hideTimeout: hideTimeout, delayTimeout: delayTimeout } = toggleIndicator(collabEditInternetLost, showIndicatorCB, hideIndicatorCB);
        return ()=>{
            clearTimeout(hideTimeout);
            clearTimeout(delayTimeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInternetLost
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabEditInternetLost) return;
        const showIndicatorCB = ()=>{
            offlineData.current = {
                browserNetworkStatus: navigator.onLine,
                documentVisibilityState: document.visibilityState,
                connectionTimeoutStartTime: performance.now()
            };
            triggerAnalyticsEvent('collab.edit.connection.timeout.show.indicator', {
                contentId: contentId,
                contentType: contentType
            });
        };
        const hideIndicatorCB = ()=>{
            if (showIndicator) // if connection timeout banner was displayed, fire analytics
            triggerAnalyticsEvent('connection.timeout.banner.displayed', {
                browserNetworkStatus: offlineData?.current.browserNetworkStatus,
                editorType: editorType,
                documentVisibilityState: offlineData?.current.documentVisibilityState,
                duration: offlineData?.current.connectionTimeoutStartTime ? performance.now() - offlineData?.current.connectionTimeoutStartTime : 0
            });
        };
        const { hideTimeout: hideTimeout, delayTimeout: delayTimeout } = toggleIndicator(collabEditConnectionTimedOut, showIndicatorCB, hideIndicatorCB);
        return ()=>{
            clearTimeout(hideTimeout);
            clearTimeout(delayTimeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditConnectionTimedOut
    ]);
    let bannerMessage;
    if (willEditorDisable) {
        if (restrictionUpdate) bannerMessage = (0, $kVuKK.i18n).editorDisabledDueToPermissionChange;
        else if (collabEditConnectionTimedOut && !collabEditInternetLost) bannerMessage = (0, $kVuKK.i18n).collabEditConnectionTimeout;
        else bannerMessage = (0, $kVuKK.i18n).editorDisabled;
    } else bannerMessage = (0, $kVuKK.i18n).editorEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StatusIndicator), {
        "data-testid": "status-indicator",
        show: showIndicator,
        showOnlineBackground: !collabEditInternetLost && !collabEditConnectionTimedOut,
        toolbarHidden: isEditorToolbarHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.FadingSpan), {
        "data-testid": "status-indicator-online-text",
        role: "alert",
        show: !collabEditInternetLost && !collabEditConnectionTimedOut && showIndicator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: "online-indicator",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StyledText), {
        mediaMaxWidth: "150px",
        "data-testid": "online-text"
    }, formatMessage((0, $kVuKK.i18n).backOnline))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.FadingSpan), {
        "data-testid": "status-indicator-offline-text",
        role: "alert",
        show: collabEditInternetLost || collabEditConnectionTimedOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.StyledText), {
        "data-testid": "offline-text"
    }, formatMessage(bannerMessage)), (collabEditInternetLost || collabEditConnectionTimedOut) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a527c2e06cc0891d$var$AnimatedEllipsis, null)));
}));
const $a527c2e06cc0891d$export$810003fd2aab11e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($a527c2e06cc0891d$var$EditorConnectionBannerComponent);
module.exports["EditorConnectionBanner"] = $a527c2e06cc0891d$export$810003fd2aab11e5;

});

parcelRegister("kVuKK", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $da4fb2730df63d94$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    editorEnabled: {
        id: "browser-status-indicator.user.offline.editor.enabled",
        defaultMessage: "We\u2019ve lost our connection to you. Your changes will be saved when we reconnect. Trying to reconnect"
    },
    editorEnabledOfflineMode: {
        id: "browser-status-indicator.user.offline.editor.offline-mode.enabled",
        defaultMessage: "You\u2019re back online. You can now use all editing features."
    },
    editorDisabled: {
        id: "browser-status-indicator.user.offline.editor.disabled",
        defaultMessage: "We\u2019ve lost our connection to you, so we\u2019ve disabled editing to prevent any issues. You\u2019ll be able to edit once we reconnect. Trying to reconnect"
    },
    editorDisabledOfflineMode: {
        id: "browser-status-indicator.user.offline.editor.offline-mode.disabled",
        defaultMessage: "Looks like you\u2019re offline. Any changes you make will be automatically saved. Some features will be unavailable."
    },
    backOnline: {
        id: "browser-status-indicator.back.online",
        defaultMessage: "Editing restored"
    },
    editorDisabledDueToPermissionChange: {
        id: "browser-status-indicator.permission.change.offline",
        defaultMessage: "The access update you made is taking longer than expected to save, so we\u2019ve disabled editing to prevent any issues. You\u2019ll be able to edit once the changes finish saving. Saving"
    },
    collabEditConnectionTimeout: {
        id: "browser-status-indicator.collab.edit.timeout",
        defaultMessage: "We\u2019ve lost our connection to you, so editing is paused to prevent any issues. You can edit again once we reconnect, but you may want to copy and save this work now. Trying to reconnect"
    },
    // TODO: Remove when platform_editor_offline_editing_web_ga_fixes is cleaned up - replaced by editorSyncFailedDueToConflictsUpdated
    editorSyncFailedDueToConflicts: {
        id: "browser-status-indicator.collab.edit.conflicts",
        defaultMessage: "{conflictIcon} We found <conflictLink>{conflictCount, plural, =1 {# conflict} other {# conflicts}}</conflictLink> while syncing your offline edits. Review them below or <saveCopy>save a copy</saveCopy> of your offline edits."
    },
    editorSyncFailedDueToConflictsUpdated: {
        id: "browser-status-indicator.collab.edit.conflicts",
        defaultMessage: "{conflictIcon} We found {conflictCount, plural, one {# conflict} other {# conflicts}} while syncing your offline edits. <conflictLink>Review conflicts</conflictLink>"
    },
    resyncingEditorDisabled: {
        id: "browser-status-indicator.user.offline.editor.resyncing-editor-disabled",
        defaultMessage: "Your offline edits are currently being synced in another tab. You\u2019ll be able to edit once your offline edits finish syncing."
    }
});
module.exports["i18n"] = $da4fb2730df63d94$export$a7357cdd1f0b0168;

});

parcelRegister("e6u60", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");

const $cb9ccc7e1f68f6bb$export$22499ff95fdadf06 = (contentId)=>{
    // grab the element object from local storage
    const { elementObject: elementObject } = $cb9ccc7e1f68f6bb$var$getScrollParams();
    // cleanup local storage once we have the object
    $cb9ccc7e1f68f6bb$var$cleanUpLocalStorageScrolls();
    // return if elementObject doesn't exist or have index and contentId properties
    if (!elementObject?.index || !elementObject?.contentId) return;
    // return if the index is -1 or stored contentId doesn't match current contentId
    if (elementObject?.index < 0 || elementObject?.contentId !== contentId) return;
    // grab the editor parent element
    const scrollParentElement = Array.from(document.getElementsByClassName((0, $dpqzw.EDITOR_PARENT_CLASS)))[0];
    // return if editor parent doesn't exist
    if (!scrollParentElement) return;
    // set scroll behavior to auto, which will make it "jump" instead of scroll
    scrollParentElement.style.scrollBehavior = 'auto';
    // grab all of the direct children elements from the editor parent
    const elements = Array.from(scrollParentElement.querySelectorAll((0, $dpqzw.EDITOR_CHILDREN_SELECTOR)));
    if (elements.length > 0) {
        const idealElement = elements[elementObject.index];
        if (idealElement) {
            // minor offset for visual whitespace
            const addtlOffset = 10;
            scrollParentElement.scrollTo({
                top: idealElement.offsetTop - addtlOffset
            });
            $cb9ccc7e1f68f6bb$var$placeCursor(idealElement);
        }
    }
    // cleanup scrollBehavior
    scrollParentElement.style.scrollBehavior = '';
};
const $cb9ccc7e1f68f6bb$var$placeCursor = (idealElement)=>{
    // we need to use range to place the cursor inside a contenteditable element
    if (document.createRange) {
        // check to see if the direct child of the selected element is a text node, and return if not
        if (!(idealElement?.childNodes[0]?.nodeType === Node.TEXT_NODE)) return;
        // sets the range to contain the contents of the idealElement node, collapse indicating it should be at the end of the text node
        const range = document.createRange();
        range.selectNodeContents(idealElement);
        range.collapse(false);
        // clear existing ranges and add the newly created range
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
};
const $cb9ccc7e1f68f6bb$var$getScrollParams = ()=>{
    return {
        elementObject: (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION)
    };
};
const $cb9ccc7e1f68f6bb$var$cleanUpLocalStorageScrolls = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION);
};
module.exports["scrollToLastViewedPosition"] = $cb9ccc7e1f68f6bb$export$22499ff95fdadf06;

});

parcelRegister("1Vx7O", function(module, exports) {
const $3b89d048e09c7153$export$d9eb6707f6a1e3a = ({ title: title, isPublishingContent: isPublishingContent, userOffline: userOffline = false, forceDisabled: forceDisabled = false })=>{
    if (userOffline || forceDisabled) // no tooltip for publish button when disabled due to internet lost, banner will be shown indicating lost connection
    // no tooltip for publish button when editor is force disabled, this happens when page is converted to blog or converted between live and non live page
    return '';
    else if (!title) return 'editor.buttons.disable.by.empty.title.tooltip';
    else if (isPublishingContent) return 'editor.buttons.disable.by.saving.tooltip';
    return '';
};
module.exports["getPublishButtonDisabledReason"] = $3b89d048e09c7153$export$d9eb6707f6a1e3a;

});


//# sourceMappingURL=FullPageEditorComponent.e5951ab6.js.map
